export const brons = {
	'Bronzen Schilden Seizoen 2022/2023': [
		{
			Seizoen: '2022-2023',
			Categorie: 'Periodekampioen',
			Periode: '1',
			Naam: 'Heracles Almelo',
			Club: 'Heracles Almelo',
		},
		{
			Seizoen: '2022-2023',
			Categorie: 'Beste Speler',
			Periode: '1',
			Naam: 'Emil Hansson',
			Club: 'Heracles Almelo',
		},
		{
			Seizoen: '2022-2023',
			Categorie: 'Beste Keeper',
			Periode: '1',
			Naam: 'Michael Brouwer',
			Club: 'Heracles Almelo',
		},
		{
			Seizoen: '2022-2023',
			Categorie: 'Beste Talent',
			Periode: '1',
			Naam: 'Soulyman Allouch',
			Club: 'Jong AZ',
		},
		{
			Seizoen: '2022-2023',
			Categorie: 'Beste Trainer',
			Periode: '1',
			Naam: 'Rob Penders',
			Club: 'FC Eindhoven',
		},
		{
			Seizoen: '2022-2023',
			Categorie: 'Topscorer',
			Periode: '1',
			Naam: 'Dylan Vente',
			Club: 'Roda JC Kerkrade',
		},
		{
			Seizoen: '2022-2023',
			Categorie: 'Periodekampioen',
			Periode: '2',
			Naam: 'PEC Zwolle',
			Club: 'PEC Zwolle',
		},
		{
			Seizoen: '2022-2023',
			Categorie: 'Beste Speler',
			Periode: '2',
			Naam: 'Thomas van den Belt',
			Club: 'PEC Zwolle',
		},
		{
			Seizoen: '2022-2023',
			Categorie: 'Beste Keeper',
			Periode: '2',
			Naam: 'Jasper Schendelaar',
			Club: 'PEC Zwolle',
		},
		{
			Seizoen: '2022-2023',
			Categorie: 'Beste Talent',
			Periode: '2',
			Naam: 'Kian Fitz-Jim',
			Club: 'Jong Ajax',
		},
		{
			Seizoen: '2022-2023',
			Categorie: 'Beste Trainer',
			Periode: '2',
			Naam: 'Maurice Verberne',
			Club: 'MVV Maastricht',
		},
		{
			Seizoen: '2022-2023',
			Categorie: 'Topscorer',
			Periode: '2',
			Naam: 'Emil Hansson',
			Club: 'Heracles Almelo',
		},
		{
			Seizoen: '2022-2023',
			Categorie: 'Periodekampioen',
			Periode: '3',
			Naam: 'Almere City FC',
			Club: 'Almere City FC',
		},
		{
			Seizoen: '2022-2023',
			Categorie: 'Beste Speler',
			Periode: '3',
			Naam: 'Apostolos Vellios',
			Club: 'PEC Zwolle',
		},
		{
			Seizoen: '2022-2023',
			Categorie: 'Beste Keeper',
			Periode: '3',
			Naam: 'Nordin Bakker',
			Club: 'Almere City FC',
		},
		{
			Seizoen: '2022-2023',
			Categorie: 'Beste Talent',
			Periode: '3',
			Naam: 'Younes Taha',
			Club: 'PEC Zwolle',
		},
		{
			Seizoen: '2022-2023',
			Categorie: 'Beste Trainer',
			Periode: '3',
			Naam: 'Dick Advocaat',
			Club: 'ADO Den Haag',
		},
		{
			Seizoen: '2022-2023',
			Categorie: 'Topscorer',
			Periode: '3',
			Naam: 'Apostolos Vellios',
			Club: 'PEC Zwolle',
		},
		{
			Seizoen: '2022-2023',
			Categorie: 'Periodekampioen',
			Periode: '4',
			Naam: 'Heracles Almelo',
			Club: 'Heracles Almelo',
		},
		{
			Seizoen: '2022-2023',
			Categorie: 'Beste Speler',
			Periode: '4',
			Naam: 'Elías Már Ómarsson',
			Club: 'NAC Breda',
		},
		{
			Seizoen: '2022-2023',
			Categorie: 'Beste Keeper',
			Periode: '4',
			Naam: 'Romain Matthys',
			Club: 'MVV Maastricht',
		},
		{
			Seizoen: '2022-2023',
			Categorie: 'Beste Talent',
			Periode: '4',
			Naam: 'Ruben van Bommel',
			Club: 'MVV Maastricht',
		},
		{
			Seizoen: '2022-2023',
			Categorie: 'Beste Trainer',
			Periode: '4',
			Naam: 'Dick Schreuder',
			Club: 'PEC Zwolle',
		},
		{
			Seizoen: '2022-2023',
			Categorie: 'Topscorer',
			Periode: '4',
			Naam: 'Lennart Thy',
			Club: 'PEC Zwolle',
		},
	],
	'Bronzen Schilden Seizoen 2021/2022': [
		{
			Seizoen: '2021-2022',
			Categorie: 'Periodekampioen',
			Periode: '1',
			Naam: 'ADO Den Haag',
			Club: 'ADO Den Haag',
		},
		{
			Seizoen: '2021-2022',
			Categorie: 'Beste Speler',
			Periode: '1',
			Naam: 'Thijs Dallinga',
			Club: 'Excelsior Rotterdam',
		},
		{
			Seizoen: '2021-2022',
			Categorie: 'Beste Keeper',
			Periode: '1',
			Naam: 'Stijn van Gassel',
			Club: 'Excelsior Rotterdam',
		},
		{
			Seizoen: '2021-2022',
			Categorie: 'Beste Talent',
			Periode: '1',
			Naam: 'Max De Waal',
			Club: 'Jong Ajax',
		},
		{
			Seizoen: '2021-2022',
			Categorie: 'Beste Trainer',
			Periode: '1',
			Naam: 'Maarten Martens',
			Club: 'Jong AZ',
		},
		{
			Seizoen: '2021-2022',
			Categorie: 'Topscorer',
			Periode: '1',
			Naam: 'Thijs Dallinga',
			Club: 'Excelsior Rotterdam',
		},
		{
			Seizoen: '2021-2022',
			Categorie: 'Periodekampioen',
			Periode: '2',
			Naam: 'Excelsior Rotterdam',
			Club: 'Excelsior Rotterdam',
		},
		{
			Seizoen: '2021-2022',
			Categorie: 'Beste Speler',
			Periode: '2',
			Naam: 'Robert Mühren',
			Club: 'FC Volendam',
		},
		{
			Seizoen: '2021-2022',
			Categorie: 'Beste Keeper',
			Periode: '2',
			Naam: 'Nick Olij',
			Club: 'NAC Breda',
		},
		{
			Seizoen: '2021-2022',
			Categorie: 'Beste Talent',
			Periode: '2',
			Naam: 'Sem Steijn',
			Club: 'ADO Den Haag',
		},
		{
			Seizoen: '2021-2022',
			Categorie: 'Beste Trainer',
			Periode: '2',
			Naam: 'John Heitinga',
			Club: 'Jong Ajax',
		},
		{
			Seizoen: '2021-2022',
			Categorie: 'Topscorer',
			Periode: '2',
			Naam: 'Thijs Dallinga',
			Club: 'Excelsior Rotterdam',
		},
		{
			Seizoen: '2021-2022',
			Categorie: 'Periodekampioen',
			Periode: '3',
			Naam: 'FC Emmen',
			Club: 'FC Emmen',
		},
		{
			Seizoen: '2021-2022',
			Categorie: 'Beste Speler',
			Periode: '3',
			Naam: 'Joey Sleegers',
			Club: 'FC Eindhoven',
		},
		{
			Seizoen: '2021-2022',
			Categorie: 'Beste Keeper',
			Periode: '3',
			Naam: 'Michael Brouwer',
			Club: 'FC Emmen',
		},
		{
			Seizoen: '2021-2022',
			Categorie: 'Beste Talent',
			Periode: '3',
			Naam: 'Johan Bakayoko',
			Club: 'Jong PSV',
		},
		{
			Seizoen: '2021-2022',
			Categorie: 'Beste Trainer',
			Periode: '3',
			Naam: 'Rob Penders',
			Club: 'FC Eindhoven',
		},
		{
			Seizoen: '2021-2022',
			Categorie: 'Topscorer',
			Periode: '3',
			Naam: 'Kay Tejan',
			Club: 'TOP Oss',
		},
		{
			Seizoen: '2021-2022',
			Categorie: 'Periodekampioen',
			Periode: '4',
			Naam: 'FC Emmen',
			Club: 'FC Emmen',
		},
		{
			Seizoen: '2021-2022',
			Categorie: 'Beste Speler',
			Periode: '4',
			Naam: 'Rui Mendes',
			Club: 'FC Emmen',
		},
		{
			Seizoen: '2021-2022',
			Categorie: 'Beste Keeper',
			Periode: '4',
			Naam: 'Nigel Bertrams',
			Club: 'FC Eindhoven',
		},
		{
			Seizoen: '2021-2022',
			Categorie: 'Beste Talent',
			Periode: '4',
			Naam: 'Benjamin Bouchouari',
			Club: 'Roda JC',
		},
		{
			Seizoen: '2021-2022',
			Categorie: 'Beste Trainer',
			Periode: '4',
			Naam: 'Dick Lukkien',
			Club: 'FC Emmen',
		},
		{
			Seizoen: '2021-2022',
			Categorie: ' Topscorer',
			Periode: '4',
			Naam: 'Thomas Verheydt',
			Club: 'ADO Den Haag',
		},
	],
	'Bronzen Schilden Seizoen 2020/2021': [
		{
			Seizoen: '2020-2021',
			Categorie: 'Periodekampioen',
			Periode: '1',
			Naam: 'SC Cambuur',
			Club: 'SC Cambuur',
		},
		{
			Seizoen: '2020-2021',
			Categorie: 'Beste Speler',
			Periode: '1',
			Naam: 'Robert Mühren',
			Club: 'SC Cambuur',
		},
		{
			Seizoen: '2020-2021',
			Categorie: 'Beste Keeper',
			Periode: '1',
			Naam: 'Nick Olij',
			Club: 'NAC Breda',
		},
		{
			Seizoen: '2021-2021',
			Categorie: 'Beste Talent',
			Periode: '1',
			Naam: 'Mohamed Taabouni',
			Club: 'Jong AZ',
		},
		{
			Seizoen: '2021-2021',
			Categorie: 'Beste Trainer',
			Periode: '1',
			Naam: 'Ole Tobiasen',
			Club: 'Almere City FC',
		},
		{
			Seizoen: '2020-2021',
			Categorie: 'Topscorer',
			Periode: '1',
			Naam: 'Elías Már Ómarsson',
			Club: 'Excelsior',
		},
		{
			Seizoen: '2020-2021',
			Categorie: 'Periodekampioen',
			Periode: '2',
			Naam: 'SC Cambuur',
			Club: 'SC Cambuur',
		},
		{
			Seizoen: '2020-2021',
			Categorie: 'Beste Speler',
			Periode: '2',
			Naam: 'Thomas Verheydt',
			Club: 'Almere City FC',
		},
		{
			Seizoen: '2020-2021',
			Categorie: 'Beste Keeper',
			Periode: '2',
			Naam: 'Jay Gorter',
			Club: 'Go Ahead Eagles',
		},
		{
			Seizoen: '2020-2021',
			Categorie: 'Beste Talent',
			Periode: '2',
			Naam: 'Micky van de Ven',
			Club: 'FC Volendam',
		},
		{
			Seizoen: '2020-2021',
			Categorie: 'Beste Trainer',
			Periode: '2',
			Naam: 'Henk de Jong',
			Club: 'SC Cambuur',
		},
		{
			Seizoen: '2020-2021',
			Categorie: 'Topscorer',
			Periode: '2',
			Naam: 'Robert Mühren',
			Club: 'SC Cambuur',
		},
		{
			Seizoen: '2020-2021',
			Categorie: 'Periodekampioen',
			Periode: '3',
			Naam: 'De Graafschap',
			Club: 'De Graafschap',
		},
		{
			Seizoen: '2020-2021',
			Categorie: 'Beste Speler',
			Periode: '3',
			Naam: 'Sam Beukema',
			Club: 'Go Ahead Eagles',
		},
		{
			Seizoen: '2020-2021',
			Categorie: 'Beste Keeper',
			Periode: '3',
			Naam: 'Sonny Stevens',
			Club: 'SC Cambuur',
		},
		{
			Seizoen: '2020-2021',
			Categorie: 'Beste Talent',
			Periode: '3',
			Naam: 'Benjamin Bouchouari',
			Club: 'Roda JC',
		},
		{
			Seizoen: '2020-2021',
			Categorie: 'Beste Trainer',
			Periode: '3',
			Naam: 'Kees van Wonderen',
			Club: 'Go Ahead Eagles',
		},
		{
			Seizoen: '2020-2021',
			Categorie: 'Topscorer',
			Periode: '3',
			Naam: 'Robert Mühren',
			Club: 'SC Cambuur',
		},
		{
			Seizoen: '2020-2021',
			Categorie: 'Periodekampioen',
			Periode: '4',
			Naam: 'SC Cambuur',
			Club: 'SC Cambuur',
		},
		{
			Seizoen: '2020-2021',
			Categorie: 'Beste Speler',
			Periode: '4',
			Naam: 'Jizz Hornkamp',
			Club: 'FC Den Bosch',
		},
		{
			Seizoen: '2020-2021',
			Categorie: 'Beste Keeper',
			Periode: '4',
			Naam: 'Stijn van Gassel',
			Club: 'Helmond Sport',
		},
		{
			Seizoen: '2020-2021',
			Categorie: 'Beste Talent',
			Periode: '4',
			Naam: 'Ringo Meerveld',
			Club: 'FC Den Bosch',
		},
		{
			Seizoen: '2020-2021',
			Categorie: 'Beste Trainer',
			Periode: '4',
			Naam: 'Wil Boessen',
			Club: 'Helmond Sport',
		},
		{
			Seizoen: '2020-2021',
			Categorie: 'Topscorer',
			Periode: '4',
			Naam: 'Robert Mühren',
			Club: 'SC Cambuur',
		},
	],
	'Bronzen Schilden Seizoen 2019/2020': [
		{
			Seizoen: '2019-2020',
			Categorie: 'Periodekampioen',
			Periode: '1',
			Naam: 'NAC Breda',
			Club: 'NAC Breda',
		},
		{
			Seizoen: '2019-2020',
			Categorie: 'Beste Speler',
			Periode: '1',
			Naam: 'Branco van den Boomen',
			Club: 'De Graafschap',
		},
		{
			Seizoen: '2019-2020',
			Categorie: 'Beste Keeper',
			Periode: '1',
			Naam: 'Nick Olij',
			Club: 'NAC Breda',
		},
		{
			Seizoen: '2019-2020',
			Categorie: 'Beste Talent',
			Periode: '1',
			Naam: 'Ryan Gravenberch',
			Club: 'Jong Ajax',
		},
		{
			Seizoen: '2019-2020',
			Categorie: 'Beste Trainer',
			Periode: '1',
			Naam: 'René Hake',
			Club: 'Jong FC Utrecht',
		},
		{
			Seizoen: '2019-2020',
			Categorie: 'Topscorer',
			Periode: '1',
			Naam: 'Robert Mühren',
			Club: 'SC Cambuur',
		},
		{
			Seizoen: '2019-2020',
			Categorie: 'Periodekampioen',
			Periode: '2',
			Naam: 'FC Volendam',
			Club: 'FC Volendam',
		},
		{
			Seizoen: '2019-2020',
			Categorie: 'Beste Speler',
			Periode: '2',
			Naam: 'Robert Mühren',
			Club: 'SC Cambuur',
		},
		{
			Seizoen: '2019-2020',
			Categorie: 'Beste Keeper',
			Periode: '2',
			Naam: 'Sonny Stevens',
			Club: 'SC Cambuur',
		},
		{
			Seizoen: '2019-2020',
			Categorie: 'Beste Talent',
			Periode: '2',
			Naam: 'Jurgen Ekkelenkamp',
			Club: 'Jong Ajax',
		},
		{
			Seizoen: '2019-2020',
			Categorie: 'Beste Trainer',
			Periode: '2',
			Naam: 'Wim Jonk',
			Club: 'FC Volendam',
		},
		{
			Seizoen: '2019-2020',
			Categorie: 'Topscorer',
			Periode: '2',
			Naam: 'Reda Kharchouch',
			Club: 'Telstar',
		},
		{
			Seizoen: '2019-2020',
			Categorie: 'Periodekampioen',
			Periode: '3',
			Naam: 'De Graafschap',
			Club: 'De Graafschap',
		},
		{
			Seizoen: '2019-2020',
			Categorie: 'Beste Speler',
			Periode: '3',
			Naam: 'Anthony van den Hurk',
			Club: 'MVV Maastricht',
		},
		{
			Seizoen: '2019-2020',
			Categorie: 'Beste Keeper',
			Periode: '3',
			Naam: 'Hidde Jurjus',
			Club: 'De Graafschap',
		},
		{
			Seizoen: '2019-2020',
			Categorie: 'Beste Talent',
			Periode: '3',
			Naam: 'Francesco Antonucci',
			Club: 'FC Volendam',
		},
		{
			Seizoen: '2019-2020',
			Categorie: 'Beste Trainer',
			Periode: '3',
			Naam: 'Henk de Jong',
			Club: 'SC Cambuur',
		},
		{
			Seizoen: '2019-2020',
			Categorie: 'Topscorer',
			Periode: '3',
			Naam: 'Robert Mühren',
			Club: 'SC Cambuur',
		},
	],
	'Bronzen Schilden Seizoen 2018/2019': [
		{
			Seizoen: '2018-2019',
			Categorie: 'Periodekampioen',
			Periode: '1',
			Naam: 'Sparta Rotterdam',
			Club: 'Sparta Rotterdam',
		},
		{
			Seizoen: '2018-2019',
			Categorie: 'Beste Speler',
			Periode: '1',
			Naam: 'Istvan Bakx',
			Club: 'Go Ahead Eagles',
		},
		{
			Seizoen: '2018-2019',
			Categorie: 'Beste Keeper',
			Periode: '1',
			Naam: 'Hobie Verhulst',
			Club: 'Go Ahead Eagles',
		},
		{
			Seizoen: '2018-2019',
			Categorie: 'Beste Talent',
			Periode: '1',
			Naam: 'Ferdy Druijf',
			Club: 'Jong AZ',
		},
		{
			Seizoen: '2018-2019',
			Categorie: 'Beste Trainer',
			Periode: '1',
			Naam: 'John Stegeman',
			Club: 'Go Ahead Eagles',
		},
		{
			Seizoen: '2018-2019',
			Categorie: 'Topscorer',
			Periode: '1',
			Naam: 'Ferdy Druijf',
			Club: 'Jong AZ',
		},
		{
			Seizoen: '2018-2019',
			Categorie: 'Periodekampioen',
			Periode: '2',
			Naam: 'FC Den Bosch',
			Club: 'FC Den Bosch',
		},
		{
			Seizoen: '2018-2019',
			Categorie: 'Beste Speler',
			Periode: '2',
			Naam: 'Lars Veldwijk',
			Club: 'Sparta Rotterdam',
		},
		{
			Seizoen: '2018-2019',
			Categorie: 'Beste Keeper',
			Periode: '2',
			Naam: 'Wouter van der Steen',
			Club: 'FC Den Bosch',
		},
		{
			Seizoen: '2018-2019',
			Categorie: 'Beste Talent',
			Periode: '2',
			Naam: 'Cody Gakpo',
			Club: 'Jong PSV',
		},
		{
			Seizoen: '2018-2019',
			Categorie: 'Beste Trainer',
			Periode: '2',
			Naam: 'Wil Boessen',
			Club: 'FC Den Bosch',
		},
		{
			Seizoen: '2018-2019',
			Categorie: 'Topscorer',
			Periode: '2',
			Naam: 'Lars Veldwijk',
			Club: 'Sparta Rotterdam',
		},
		{
			Seizoen: '2018-2019',
			Categorie: 'Periodekampioen',
			Periode: '3',
			Naam: 'FC Twente',
			Club: 'FC Twente',
		},
		{
			Seizoen: '2018-2019',
			Categorie: 'Beste Speler',
			Periode: '3',
			Naam: 'Aitor Cantalapiedra',
			Club: 'FC Twente',
		},
		{
			Seizoen: '2018-2019',
			Categorie: 'Beste Keeper',
			Periode: '3',
			Naam: 'Joël Drommel',
			Club: 'FC Twente',
		},
		{
			Seizoen: '2018-2019',
			Categorie: 'Beste Talent',
			Periode: '3',
			Naam: 'Halil Dervisoglu',
			Club: 'Sparta Rotterdam',
		},
		{
			Seizoen: '2018-2019',
			Categorie: 'Beste Trainer',
			Periode: '3',
			Naam: 'Marino Pusic',
			Club: 'FC Twente',
		},
		{
			Seizoen: '2018-2019',
			Categorie: 'Topscorer',
			Periode: '3',
			Naam: 'Ferdy Druijf',
			Club: 'N.E.C.',
		},
		{
			Seizoen: '2018-2019',
			Categorie: 'Periodekampioen',
			Periode: '4',
			Naam: 'Almere City FC',
			Club: 'Almere City FC',
		},
		{
			Seizoen: '2018-2019',
			Categorie: 'Beste Speler',
			Periode: '4',
			Naam: 'Terell Ondaan',
			Club: 'Telstar',
		},
		{
			Seizoen: '2018-2019',
			Categorie: 'Beste Keeper',
			Periode: '4',
			Naam: 'Xavier Mous',
			Club: 'SC Cambuur',
		},
		{
			Seizoen: '2018-2019',
			Categorie: 'Beste Talent',
			Periode: '4',
			Naam: 'Kenzo Goudmijn',
			Club: 'Jong AZ',
		},
		{
			Seizoen: '2018-2019',
			Categorie: 'Beste Trainer',
			Periode: '4',
			Naam: 'Ole Tobiasen',
			Club: 'Almere City FC',
		},
		{
			Seizoen: '2018-2019',
			Categorie: 'Topscorer',
			Periode: '4',
			Naam: 'Lars Veldwijk',
			Club: 'Sparta Rotterdam',
		},
	],
};

export const gouden_schild = {
	'Gouden Schilden seizoen 2022/2023': [
		{
			Seizoen: '2022-2023',
			Categorie: 'Kampioen',
			Naam: 'Heracles Almelo',
			Club: 'Heracles Almelo',
		},
		{
			Seizoen: '2022-2023',
			Categorie: 'Beste Speler',
			Naam: 'Thomas van den Belt',
			Club: 'PEC Zwolle',
		},
		{
			Seizoen: '2022-2023',
			Categorie: 'Beste Keeper',
			Naam: 'Michael Brouwer',
			Club: 'Heracles Almelo',
		},
		{
			Seizoen: '2022-2023',
			Categorie: 'Beste Talent',
			Naam: 'Ruben van Bommel',
			Club: 'MVV Maastricht',
		},
		{
			Seizoen: '2022-2023',
			Categorie: 'Beste Trainer',
			Naam: 'Dick Schreuder',
			Club: 'PEC Zwolle',
		},
		{
			Seizoen: '2022-2023',
			Categorie: 'Topscorer',
			Naam: 'Lennart Thy',
			Club: 'PEC Zwolle',
		},
	],
	'Gouden Schilden seizoen 2021/2022': [
		{
			Seizoen: '2021-2022',
			Categorie: 'Kampioen',
			Naam: 'FC Emmen',
			Club: 'FC Emmen',
		},
		{
			Seizoen: '2021-2022',
			Categorie: 'Beste Speler',
			Naam: 'Robert Mühren',
			Club: 'FC Volendam',
		},
		{
			Seizoen: '2021-2022',
			Categorie: 'Beste Keeper',
			Naam: 'Nick Olij',
			Club: 'NAC Breda',
		},
		{
			Seizoen: '2021-2022',
			Categorie: 'Beste Talent',
			Naam: 'Johan Bakayoko',
			Club: 'Jong PSV',
		},
		{
			Seizoen: '2021-2022',
			Categorie: 'Beste Trainer',
			Naam: 'Dick Lukkien',
			Club: 'FC Emmen',
		},
		{
			Seizoen: '2021-2022',
			Categorie: 'Topscorer',
			Naam: 'Thijs Dallinga',
			Club: 'Excelsior',
		},
	],
	'Gouden Schilden seizoen 2020/2021': [
		{
			Seizoen: '2020-2021',
			Categorie: 'Kampioen',
			Naam: 'SC Cambuur',
			Club: 'SC Cambuur',
		},
		{
			Seizoen: '2020-2021',
			Categorie: 'Beste Speler',
			Naam: 'Robert Mühren',
			Club: 'SC Cambuur',
		},
		{
			Seizoen: '2020-2021',
			Categorie: 'Beste Keeper',
			Naam: 'Jay Gorter',
			Club: 'Go Ahead Eagles',
		},
		{
			Seizoen: '2020-2021',
			Categorie: 'Beste Talent',
			Naam: 'Micky van de Ven',
			Club: 'FC Volendam',
		},
		{
			Seizoen: '2020-2021',
			Categorie: 'Beste Trainer',
			Naam: 'Henk de Jong',
			Club: 'SC Cambuur',
		},
		{
			Seizoen: '2020-2021',
			Categorie: 'Topscorer',
			Naam: 'Robert Mühren',
			Club: 'SC Cambuur',
		},
	],
	'Gouden Schilden seizoen 2018/2019': [
		{
			Seizoen: '2018-2019',
			Categorie: 'Kampioen',
			Naam: 'FC Twente',
			Club: 'FC Twente',
		},
		{
			Seizoen: '2018-2019',
			Categorie: 'Beste Speler',
			Naam: 'Aitor Cantalapiedra',
			Club: 'FC Twente',
		},
		{
			Seizoen: '2018-2019',
			Categorie: 'Beste Keeper',
			Naam: 'Joël Drommel',
			Club: 'FC Twente',
		},
		{
			Seizoen: '2018-2019',
			Categorie: 'Beste Talent',
			Naam: 'Ferdy Druijf',
			Club: 'N.E.C.',
		},
		{
			Seizoen: '2018-2019',
			Categorie: 'Beste Trainer',
			Naam: 'Marino Pusic',
			Club: 'FC Twente',
		},
		{
			Seizoen: '2018-2019',
			Categorie: 'Topscorer',
			Naam: 'Ferdy Druijf',
			Club: 'N.E.C.',
		},
	],
};

export const bronzen_stier = {
	'Bronzen Stieren seizoen 2017/2018': [
		{
			Seizoen: '2017-2018',
			Categorie: 'Periodekampioen',
			Periode: '1',
			Naam: 'Jong Ajax',
			Club: 'Jong Ajax',
		},
		{
			Seizoen: '2017-2018',
			Categorie: 'Beste Speler',
			Periode: '1',
			Naam: 'Sam Hendriks',
			Club: 'Go Ahead Eagles',
		},
		{
			Seizoen: '2017-2018',
			Categorie: 'Beste Trainer',
			Periode: '1',
			Naam: 'Sunday Oliseh',
			Club: 'Fortuna Sittard',
		},
		{
			Seizoen: '2017-2018',
			Categorie: 'Beste Talent',
			Periode: '1',
			Naam: 'Perr Schuurs',
			Club: 'Fortuna Sittard',
		},
		{
			Seizoen: '2017-2018',
			Categorie: 'Topscorer',
			Periode: '1',
			Naam: 'Mart Lieder',
			Club: 'FC Eindhoven',
		},
		{
			Seizoen: '2017-2018',
			Categorie: 'Periodekampioen',
			Periode: '2',
			Naam: 'Fortuna Sittard',
			Club: 'Fortuna Sittard',
		},
		{
			Seizoen: '2017-2018',
			Categorie: 'Beste Speler',
			Periode: '2',
			Naam: 'Lisandro Semedo',
			Club: 'Fortuna Sittard',
		},
		{
			Seizoen: '2017-2018',
			Categorie: 'Beste Trainer',
			Periode: '2',
			Naam: 'Mike Snoei',
			Club: 'Telstar',
		},
		{
			Seizoen: '2017-2018',
			Categorie: 'Beste Talent',
			Periode: '2',
			Naam: 'Donyell Malen',
			Club: 'Jong PSV',
		},
		{
			Seizoen: '2017-2018',
			Categorie: 'Topscorer',
			Periode: '2',
			Naam: 'Anass Achahbar',
			Club: 'N.E.C.',
		},
		{
			Seizoen: ' 2017-2018',
			Categorie: 'Periodekampioen',
			Periode: '3',
			Naam: 'FC Dordrecht',
			Club: 'FC Dordrecht',
		},
		{
			Seizoen: '2017-2018',
			Categorie: 'Beste Speler',
			Periode: '3',
			Naam: 'Mark Diemers',
			Club: 'De Graafschap',
		},
		{
			Seizoen: '2017-2018',
			Categorie: 'Beste Trainer',
			Periode: '3',
			Naam: 'Dick Lukkien',
			Club: 'FC Emmen',
		},
		{
			Seizoen: '2017-2018',
			Categorie: 'Beste Talent',
			Periode: '3',
			Naam: 'Ferdi Kadioglu',
			Club: 'N.E.C.',
		},
		{
			Seizoen: '2017-2018',
			Categorie: 'Topscorer',
			Periode: '3',
			Naam: 'Andrija Novakovich',
			Club: 'Telstar',
		},
		{
			Seizoen: '2017-2018',
			Categorie: 'Periodekampioen',
			Periode: '4',
			Naam: 'Fortuna Sittard',
			Club: 'Fortuna Sittard',
		},
		{
			Seizoen: '2017-2018',
			Categorie: 'Beste Speler',
			Periode: '4',
			Naam: 'Tarik Tissoudali',
			Club: 'De Graafschap',
		},
		{
			Seizoen: '2017-2018',
			Categorie: 'Beste Trainer',
			Periode: '4',
			Naam: 'Claudio Braga',
			Club: 'Fortuna Sittard',
		},
		{
			Seizoen: '2017-2018',
			Categorie: 'Beste Talent',
			Periode: '4',
			Naam: 'Nikolai Laursen',
			Club: 'Jong PSV',
		},
		{
			Seizoen: '2017-2018',
			Categorie: 'Topscorer',
			Periode: '4',
			Naam: 'Mart Lieder',
			Club: ' FC Eindhoven',
		},
	],
	'Bronzen Stieren seizoen 2016/2017': [
		{
			Seizoen: '2016-2017',
			Categorie: 'Periodekampioen',
			Periode: '1',
			Naam: 'Jong PSV',
			Club: 'Jong PSV',
		},
		{
			Seizoen: '2016-2017',
			Categorie: 'Beste speler',
			Periode: '1',
			Naam: 'Abdelhak Nouri',
			Club: 'Jong Ajax',
		},
		{
			Seizoen: '2016-2017',
			Categorie: 'Beste trainer',
			Periode: '1',
			Naam: 'Pascal Jansen',
			Club: 'Jong PSV',
		},
		{
			Seizoen: '2016-2017',
			Categorie: 'Beste talent',
			Periode: '1',
			Naam: 'Sam Lammers',
			Club: 'Jong PSV',
		},
		{
			Seizoen: '2016-2017',
			Categorie: 'Topscorer',
			Periode: '1',
			Naam: 'Sam Lammers',
			Club: 'Jong PSV',
		},
		{
			Seizoen: '2016-2017',
			Categorie: 'Periodekampioen',
			Periode: '2',
			Naam: 'VVV-Venlo',
			Club: 'VVV-Venlo',
		},
		{
			Seizoen: '2016-2017',
			Categorie: 'Beste speler',
			Periode: '2',
			Naam: 'Tom Boere',
			Club: 'FC Oss',
		},
		{
			Seizoen: '2016-2017',
			Categorie: 'Beste trainer',
			Periode: '2',
			Naam: 'Roy Hendriksen',
			Club: 'Helmond Sport',
		},
		{
			Seizoen: '2016-2017',
			Categorie: 'Beste talent',
			Periode: '2',
			Naam: 'Frenkie de Jong',
			Club: 'Jong Ajax',
		},
		{
			Seizoen: '2016-2017',
			Categorie: 'Topscorer',
			Periode: '2',
			Naam: 'Tom Boere',
			Club: 'FC Oss',
		},
		{
			Seizoen: '2016-2017',
			Categorie: 'Periodekampioen',
			Periode: '3',
			Naam: 'Jong Ajax',
			Club: 'Jong Ajax',
		},
		{
			Seizoen: '2016-2017',
			Categorie: 'Beste speler',
			Periode: '3',
			Naam: 'Jamiro Monteiro',
			Club: 'SC Cambuur',
		},
		{
			Seizoen: '2016-2017',
			Categorie: 'Beste trainer',
			Periode: '3',
			Naam: 'Maurice Steijn',
			Club: 'VVV-Venlo',
		},
		{
			Seizoen: '2016-2017',
			Categorie: 'Beste talent',
			Periode: '3',
			Naam: 'Joey Veerman',
			Club: 'FC Volendam',
		},
		{
			Seizoen: '2016-2017',
			Categorie: 'Topscorer',
			Periode: '3',
			Naam: 'Tom Boere',
			Club: 'FC Oss',
		},
		{
			Seizoen: '2016-2017',
			Categorie: 'Periodekampioen',
			Periode: '4',
			Naam: 'SC Cambuur',
			Club: 'SC Cambuur',
		},
		{
			Seizoen: '2016-2017',
			Categorie: 'Beste speler',
			Periode: '4',
			Naam: 'Sander van de Streek',
			Club: 'SC Cambuur',
		},
		{
			Seizoen: '2016-2017',
			Categorie: 'Beste trainer',
			Periode: '4',
			Naam: 'Sipke Hulshoff',
			Club: 'SC Cambuur',
		},
		{
			Seizoen: '2016-2017',
			Categorie: 'Beste talent',
			Periode: '4',
			Naam: 'Manuel García',
			Club: 'NAC Breda',
		},
		{
			Seizoen: '2016-2017',
			Categorie: 'Topscorer',
			Periode: '4',
			Naam: 'Sander van de Streek',
			Club: 'SC Cambuur',
		},
	],
	'Bronzen Stieren seizoen 2015/2016': [
		{
			Seizoen: '2015-2016',
			Categorie: 'Periodekampioen',
			Periode: '1',
			Naam: 'FC Volendam',
			Club: 'FC Volendam',
		},
		{
			Seizoen: '2015-2016',
			Categorie: 'Beste speler',
			Periode: '1',
			Naam: 'Thomas Verhaar',
			Club: 'Sparta Rotterdam',
		},
		{
			Seizoen: '2015-2016',
			Categorie: 'Beste trainer',
			Periode: '1',
			Naam: 'Robert Molenaar',
			Club: 'FC Volendam',
		},
		{
			Seizoen: '2015-2016',
			Categorie: 'Beste talent',
			Periode: '1',
			Naam: 'Gyliano van Velzen',
			Club: 'FC Volendam',
		},
		{
			Seizoen: '2015-2016',
			Categorie: 'Topscorer',
			Periode: '1',
			Naam: 'Thomas Verhaar',
			Club: 'Sparta Rotterdam',
		},
		{
			Seizoen: '2015-2016',
			Categorie: 'Periodekampioen',
			Periode: '2',
			Naam: 'Sparta Rotterdam',
			Club: 'Sparta Rotterdam',
		},
		{
			Seizoen: '2015-2016',
			Categorie: 'Beste speler',
			Periode: '2',
			Naam: 'Leon de Kogel',
			Club: 'Go Ahead Eagles',
		},
		{
			Seizoen: '2015-2016',
			Categorie: 'Beste trainer',
			Periode: '2',
			Naam: 'Alex Pastoor',
			Club: 'Sparta Rotterdam',
		},
		{
			Seizoen: '2015-2016',
			Categorie: 'Beste talent',
			Periode: '2',
			Naam: 'Vito van Crooy',
			Club: 'VVV-Venlo',
		},
		{
			Seizoen: '2015-2016',
			Categorie: 'Topscorer',
			Periode: '2',
			Naam: 'Ralf Seuntjens',
			Club: 'VVV-Venlo',
		},
		{
			Seizoen: '2015-2016',
			Categorie: 'Periodekampioen',
			Periode: '3',
			Naam: 'FC Eindhoven',
			Club: 'FC Eindhoven',
		},
		{
			Seizoen: '2015-2016',
			Categorie: 'Beste speler',
			Periode: '3',
			Naam: 'Tarik Tissoudali',
			Club: 'Telstar',
		},
		{
			Seizoen: '2015-2016',
			Categorie: 'Beste trainer',
			Periode: '3',
			Naam: 'Mitchell van der Gaag',
			Club: 'FC Eindhoven',
		},
		{
			Seizoen: '2015-2016',
			Categorie: 'Beste talent',
			Periode: '3',
			Naam: 'Jinty Caenepeel',
			Club: 'FC Eindhoven',
		},
		{
			Seizoen: '2015-2016',
			Categorie: 'Topscorer',
			Periode: '3',
			Naam: 'Ralf Seuntjens',
			Club: 'VVV-Venlo',
		},
		{
			Seizoen: '2015-2016',
			Categorie: 'Periodekampioen',
			Periode: '4',
			Naam: 'Almere City FC',
			Club: 'Almere City FC',
		},
		{
			Seizoen: '2015-2016',
			Categorie: 'Beste speler',
			Periode: '4',
			Naam: 'Ricardo Kip',
			Club: 'Almere City FC',
		},
		{
			Seizoen: '2015-2016',
			Categorie: 'Beste trainer',
			Periode: '4',
			Naam: 'Jack de Gier',
			Club: 'Almere City FC',
		},
		{
			Seizoen: '2015-2016',
			Categorie: 'Beste talent',
			Periode: '4',
			Naam: 'Denzel Dumfries',
			Club: 'Sparta Rotterdam',
		},
		{
			Seizoen: '2015-2016',
			Categorie: 'Topscorer',
			Periode: '4',
			Naam: 'Sjoerd Ars',
			Club: 'NAC Breda',
		},
	],
	'Bronzen Stieren seizoen 2014/2015': [
		{
			Seizoen: '2014-2015',
			Categorie: 'Periodekampioen',
			Periode: '1',
			Naam: 'NEC Nijmegen',
			Club: 'NEC Nijmegen',
		},
		{
			Seizoen: '2014-2015',
			Categorie: 'Beste speler',
			Periode: '1',
			Naam: 'Alireza Jahanbakhsh',
			Club: 'NEC Nijmegen',
		},
		{
			Seizoen: '2014-2015',
			Categorie: 'Beste trainer',
			Periode: '1',
			Naam: 'Jean-Paul de Jong',
			Club: 'FC Eindhoven',
		},
		{
			Seizoen: '2014-2015',
			Categorie: 'Beste talent',
			Periode: '1',
			Naam: 'Dean Koolhof',
			Club: 'De Graafschap',
		},
		{
			Seizoen: '2014-2015',
			Categorie: 'Topscorer',
			Periode: '1',
			Naam: 'Sjoerd Ars',
			Club: 'NEC Nijmegen',
		},
		{
			Seizoen: '2014-2015',
			Categorie: 'Periodekampioen',
			Periode: '2',
			Naam: 'Almere City FC',
			Club: 'Almere City FC',
		},
		{
			Seizoen: '2014-2015',
			Categorie: 'Beste speler',
			Periode: '2',
			Naam: 'Vincent Janssen',
			Club: 'Almere City FC',
		},
		{
			Seizoen: '2014-2015',
			Categorie: 'Beste trainer',
			Periode: '2',
			Naam: 'Fred Grim',
			Club: 'Almere City FC',
		},
		{
			Seizoen: '2014-2015',
			Categorie: 'Beste talent',
			Periode: '2',
			Naam: 'Vincent Janssen',
			Club: 'Almere City FC',
		},
		{
			Seizoen: '2014-2015',
			Categorie: 'Topscorer',
			Periode: '2',
			Naam: 'Rihairo Zivkovic',
			Club: 'Jong Ajax',
		},
		{
			Seizoen: '2014-2015',
			Categorie: 'Periodekampioen',
			Periode: '3',
			Naam: 'FC Oss',
			Club: 'FC Oss',
		},
		{
			Seizoen: '2014-2015',
			Categorie: 'Beste speler',
			Periode: '3',
			Naam: 'Joey Sleegers',
			Club: 'FC Eindhoven',
		},
		{
			Seizoen: '2014-2015',
			Categorie: 'Beste trainer',
			Periode: '3',
			Naam: 'Ruud Brood',
			Club: 'NEC Nijmegen',
		},
		{
			Seizoen: '2014-2015',
			Categorie: 'Beste talent',
			Periode: '3',
			Naam: 'Branco van den Boomen',
			Club: 'FC Eindhoven',
		},
		{
			Seizoen: '2014-2015',
			Categorie: 'Topscorer',
			Periode: '3',
			Naam: 'Kevin Brands',
			Club: 'FC Volendam',
		},
		{
			Seizoen: '2014-2015',
			Categorie: 'Periodekampioen',
			Periode: '4',
			Naam: 'FC Eindhoven',
			Club: 'FC Eindhoven',
		},
		{
			Seizoen: '2014-2015',
			Categorie: 'Beste speler',
			Periode: '4',
			Naam: 'Johnatan Opoku',
			Club: 'FC Oss',
		},
		{
			Seizoen: '2014-2015',
			Categorie: 'Beste trainer',
			Periode: '4',
			Naam: 'Wil Boesen',
			Club: 'FC Oss',
		},
		{
			Seizoen: '2014-2015',
			Categorie: 'Beste talent',
			Periode: '4',
			Naam: 'Joey Sleegers',
			Club: 'FC Eindhoven',
		},
		{
			Seizoen: '2014-2015',
			Categorie: 'Topscorer',
			Periode: '4',
			Naam: 'Sjoerd Ars',
			Club: 'NEC Nijmegen',
		},
	],
	'Bronzen Stieren seizoen 2013/2014': [
		{
			Seizoen: '2013-2014',
			Categorie: 'Periodekampioen',
			Periode: '1',
			Naam: 'FC Dordrecht',
			Club: 'FC Dordrecht',
		},
		{
			Seizoen: '2013-2014',
			Categorie: 'Beste speler',
			Periode: '1',
			Naam: 'Ruud Boymans',
			Club: 'Willem II',
		},
		{
			Seizoen: '2013-2014',
			Categorie: 'Beste trainer',
			Periode: '1',
			Naam: 'Harry van der Ham',
			Club: 'FC Dordrecht',
		},
		{
			Seizoen: '2013-2014',
			Categorie: 'Beste talent',
			Periode: '1',
			Naam: 'Terrell Ondaan',
			Club: 'Willem II',
		},
		{
			Seizoen: '2013-2014',
			Categorie: 'Topscorer',
			Periode: '1',
			Naam: 'Robert Mühren',
			Club: 'FC Volendam',
		},
		{
			Seizoen: '2013-2014',
			Categorie: 'Periodekampioen',
			Periode: '2',
			Naam: 'Jong PSV',
			Club: 'Jong PSV',
		},
		{
			Seizoen: '2013-2014',
			Categorie: 'Beste speler',
			Periode: '2',
			Naam: 'Yoëll van Nieff',
			Club: 'FC Dordrecht',
		},
		{
			Seizoen: '2013-2014',
			Categorie: 'Beste trainer',
			Periode: '2',
			Naam: 'Darije Kalezic',
			Club: 'Jong PSV',
		},
		{
			Seizoen: '2013-2014',
			Categorie: 'Beste talent',
			Periode: '2',
			Naam: 'Yoëll van Nieff',
			Club: 'FC Dordrecht',
		},
		{
			Seizoen: '2013-2014',
			Categorie: 'Topscorer',
			Periode: '2',
			Naam: 'Giovanni Korte',
			Club: 'FC Dordrecht',
		},
		{
			Seizoen: '2013-2014',
			Categorie: 'Periodekampioen',
			Periode: '3',
			Naam: 'VVV-Venlo',
			Club: 'VVV-Venlo',
		},
		{
			Seizoen: '2013-2014',
			Categorie: 'Beste speler',
			Periode: '3',
			Naam: 'Lars Veldwijk',
			Club: 'Excelsior',
		},
		{
			Seizoen: '2013-2014',
			Categorie: 'Beste trainer',
			Periode: '3',
			Naam: 'René Trost',
			Club: 'VVV-Venlo',
		},
		{
			Seizoen: '2013-2014',
			Categorie: 'Beste talent',
			Periode: '3',
			Naam: 'Selman Sevinç',
			Club: 'VVV-Venlo',
		},
		{
			Seizoen: '2013-2014',
			Categorie: 'Topscorer',
			Periode: '3',
			Naam: 'Lars Veldwijk',
			Club: 'Excelsior',
		},
		{
			Seizoen: '2013-2014',
			Categorie: 'Periodekampioen',
			Periode: '4',
			Naam: 'Willem II',
			Club: 'Willem II',
		},
		{
			Seizoen: '2013-2014',
			Categorie: 'Beste speler',
			Periode: '4',
			Naam: 'Bruno Andrade',
			Club: 'Willem II',
		},
		{
			Seizoen: '2013-2014',
			Categorie: 'Beste trainer',
			Periode: '4',
			Naam: 'Jurgen Streppel',
			Club: 'Willem II',
		},
		{
			Seizoen: '2013-2014',
			Categorie: 'Beste talent',
			Periode: '4',
			Naam: 'Bilal Ould-Chikh',
			Club: 'Jong FC Twente',
		},
		{
			Seizoen: '2013-2014',
			Categorie: 'Topscorer',
			Periode: '4',
			Naam: 'Paul Gladon',
			Club: 'FC Dordrecht',
		},
	],
	'Bronzen Stieren seizoen 2012/2013': [
		{
			Seizoen: '2012-2013',
			Categorie: 'Periodekampioen',
			Periode: '1',
			Naam: 'MVV Maastricht',
			Club: 'MVV Maastricht',
		},
		{
			Seizoen: '2012-2013',
			Categorie: 'Beste speler',
			Periode: '1',
			Naam: 'Emrullah Guvenc',
			Club: 'Helmond Sport',
		},
		{
			Seizoen: '2012-2013',
			Categorie: 'Beste trainer',
			Periode: '1',
			Naam: 'René Trost',
			Club: 'MVV Maastricht',
		},
		{
			Seizoen: '2012-2013',
			Categorie: 'Beste talent',
			Periode: '1',
			Naam: 'Quincy Promes',
			Club: 'Go Ahead Eagles',
		},
		{
			Seizoen: '2012-2013',
			Categorie: 'Topscorer',
			Periode: '1',
			Naam: 'Emrullah Guvenc',
			Club: 'Helmond Sport',
		},
		{
			Seizoen: '2012-2013',
			Categorie: 'Periodekampioen',
			Periode: '2',
			Naam: 'Sparta Rotterdam',
			Club: 'Sparta Rotterdam',
		},
		{
			Seizoen: '2012-2013',
			Categorie: 'Beste speler',
			Periode: '2',
			Naam: 'Joey Suk',
			Club: 'Go Ahead Eagles',
		},
		{
			Seizoen: '2012-2013',
			Categorie: 'Beste trainer',
			Periode: '2',
			Naam: 'Fred Grim',
			Club: 'Almere City FC',
		},
		{
			Seizoen: '2012-2013',
			Categorie: 'Beste talent',
			Periode: '2',
			Naam: 'Iliass Bel Hassani',
			Club: 'Sparta Rotterdam',
		},
		{
			Seizoen: '2012-2013',
			Categorie: 'Topscorer',
			Periode: '2',
			Naam: 'Marnix Kolder',
			Club: 'Go Ahead Eagles',
		},
		{
			Seizoen: '2012-2013',
			Categorie: 'Periodekampioen',
			Periode: '3',
			Naam: 'De Graafschap',
			Club: 'De Graafschap',
		},
		{
			Seizoen: '2012-2013',
			Categorie: 'Beste speler',
			Periode: '3',
			Naam: 'Anco Jansen',
			Club: 'De Graafschap',
		},
		{
			Seizoen: '2012-2013',
			Categorie: 'Beste trainer',
			Periode: '3',
			Naam: 'Pieter Huistra',
			Club: 'De Graafschap',
		},
		{
			Seizoen: '2012-2013',
			Categorie: 'Beste talent',
			Periode: '3',
			Naam: 'Brandley Kuwas',
			Club: 'FC Volendam',
		},
		{
			Seizoen: '2012-2013',
			Categorie: 'Top scorer',
			Periode: '3',
			Naam: 'Anco Jansen',
			Club: 'De Graafschap',
		},
		{
			Seizoen: '2012-2013',
			Categorie: 'Periodekampioen',
			Periode: '4',
			Naam: 'FC Volendam',
			Club: 'FC Volendam',
		},
		{
			Seizoen: '2012-2013',
			Categorie: 'Beste speler',
			Periode: '4',
			Naam: 'Jack Tuyp',
			Club: 'FC Volendam',
		},
		{
			Seizoen: '2012-2013',
			Categorie: 'Beste trainer',
			Periode: '4',
			Naam: 'Hans de Koning',
			Club: 'FC Volendam',
		},
		{
			Seizoen: '2012-2013',
			Categorie: 'Beste talent',
			Periode: '4',
			Naam: 'Brandley Kuwas',
			Club: 'FC Volendam',
		},
		{
			Seizoen: '2012-2013',
			Categorie: 'Topscorer',
			Periode: '4',
			Naam: 'Mick van Buren',
			Club: 'Excelsior',
		},
	],
	'Bronzen Stieren seizoen 2011/2012': [
		{
			Seizoen: '2011-2012',
			Categorie: 'Periodekampioen',
			Periode: '1',
			Naam: 'FC Zwolle',
			Club: 'FC Zwolle',
		},
		{
			Seizoen: '2011-2012',
			Categorie: 'Beste speler',
			Periode: '1',
			Naam: 'Anco Jansen',
			Club: 'BV Veendam',
		},
		{
			Seizoen: '2011-2012',
			Categorie: 'Beste trainer',
			Periode: '1',
			Naam: 'Ernest Faber',
			Club: 'FC Eindhoven',
		},
		{
			Seizoen: '2011-2012',
			Categorie: 'Beste talent',
			Periode: '1',
			Naam: 'Bob Schepers',
			Club: 'SC Cambuur',
		},
		{
			Seizoen: '2011-2012',
			Categorie: 'Top scorer',
			Periode: '1',
			Naam: 'Jack Tuyp',
			Club: 'FC Volendam',
		},
		{
			Seizoen: '2011-2012',
			Categorie: 'Periodekampioen',
			Periode: '2',
			Naam: 'FC Den Bosch',
			Club: 'FC Den Bosch',
		},
		{
			Seizoen: '2011-2012',
			Categorie: 'Beste Speler',
			Periode: '2',
			Naam: 'Arne Slot',
			Club: 'FC Zwolle',
		},
		{
			Seizoen: '2011-2012',
			Categorie: 'Beste Trainer',
			Periode: '2',
			Naam: 'Art Langeler',
			Club: 'FC Zwolle',
		},
		{
			Seizoen: '2011-2012',
			Categorie: 'Beste Talent',
			Periode: '2',
			Naam: 'Youness Mokhtar',
			Club: 'FC Eindhoven',
		},
		{
			Seizoen: '2011-2012',
			Categorie: 'Topscorer',
			Periode: '2',
			Naam: 'Jack Tuyp',
			Club: 'FC Volendam',
		},
		{
			Seizoen: '2011-2012',
			Categorie: 'Periodekampioen',
			Periode: '3',
			Naam: 'Sparta Rotterdam',
			Club: 'Sparta Rotterdam',
		},
		{
			Seizoen: '2011-2012',
			Categorie: 'Beste speler',
			Periode: '3',
			Naam: 'Danny Hoesen',
			Club: 'Fortuna Sittard',
		},
		{
			Seizoen: '2011-2012',
			Categorie: 'Beste trainer',
			Periode: '3',
			Naam: 'Michel Vonk',
			Club: 'Sparta Rotterdam',
		},
		{
			Seizoen: '2011-2012',
			Categorie: 'Beste talent',
			Periode: '3',
			Naam: 'Iliass Bel Hassani',
			Club: 'Sparta Rotterdam',
		},
		{
			Seizoen: '2011-2012',
			Categorie: 'Topscorer',
			Periode: '3',
			Naam: 'Erik Quekel',
			Club: 'Helmond Sport',
		},
		{
			Seizoen: '2011-2012',
			Categorie: 'Periodekampioen',
			Periode: '4',
			Naam: 'Helmond Sport',
			Club: 'Helmond Sport',
		},
		{
			Seizoen: '2011-2012',
			Categorie: 'Beste speler',
			Periode: '4',
			Naam: 'Erik Quekel',
			Club: 'Helmond Sport',
		},
		{
			Seizoen: '2011-2012',
			Categorie: 'Beste trainer',
			Periode: '4',
			Naam: 'Hans de Koning',
			Club: 'Helmond Sport',
		},
		{
			Seizoen: '2011-2012',
			Categorie: 'Beste talent',
			Periode: '4',
			Naam: 'Leroy Labylle',
			Club: 'MVV Maastricht',
		},
		{
			Seizoen: '2011-2012',
			Categorie: 'Topscorer',
			Periode: '4',
			Naam: 'Joey Suk',
			Club: 'Go Ahead Eagles',
		},
	],
	'Bronzen Stieren seizoen 2010/2011': [
		{
			Seizoen: '2010-2011',
			Categorie: 'Periodekampioen',
			Periode: '1',
			Naam: 'FC Zwolle',
			Club: 'FC Zwolle',
		},
		{
			Seizoen: '2010-2011',
			Categorie: 'Beste Trainer',
			Periode: '1',
			Naam: 'Ernest Faber',
			Club: 'FC Eindhoven',
		},
		{
			Seizoen: '2010-2011',
			Categorie: 'Beste Speler',
			Periode: '1',
			Naam: 'John Verhoek',
			Club: 'FC Den Bosch',
		},
		{
			Seizoen: '2010-2011',
			Categorie: 'Beste Talent',
			Periode: '1',
			Naam: 'Rochdi Achenteh',
			Club: 'FC Eindhoven',
		},
		{
			Seizoen: '2010-2011',
			Categorie: 'Topscorer',
			Periode: '1',
			Naam: 'Sjoerd Ars',
			Club: 'FC Zwolle',
		},
		{
			Seizoen: '2010-2011',
			Categorie: 'Periodekampioen',
			Periode: '2',
			Naam: 'FC Volendam',
			Club: 'FC Volendam',
		},
		{
			Seizoen: '2010-2011',
			Categorie: 'Beste Trainer',
			Periode: '2',
			Naam: 'Art Langeler',
			Club: 'FC Zwolle',
		},
		{
			Seizoen: '2010-2011',
			Categorie: 'Beste Speler',
			Periode: '2',
			Naam: 'Sjoerd Ars',
			Club: 'FC Zwolle',
		},
		{
			Seizoen: '2010-2011',
			Categorie: 'Beste Talent',
			Periode: '2',
			Naam: 'Tjaronn Chery',
			Club: 'FC Emmen',
		},
		{
			Seizoen: '2010-2011',
			Categorie: 'Topscorer',
			Periode: '2',
			Naam: 'Sjoerd Ars',
			Club: 'FC Zwolle',
		},
		{
			Seizoen: '2010-2011',
			Categorie: 'Periodekampioen',
			Periode: '3',
			Naam: 'MVV Maastricht',
			Club: 'MVV Maastricht',
		},
		{
			Seizoen: '2010-2011',
			Categorie: 'Beste Trainer',
			Periode: '3',
			Naam: 'René Trost',
			Club: 'MVV Maastricht',
		},
		{
			Seizoen: '2010-2011',
			Categorie: 'Beste Speler',
			Periode: '3',
			Naam: 'Tom Daemen',
			Club: 'MVV Maastricht',
		},
		{
			Seizoen: '2010-2011',
			Categorie: 'Beste Talent',
			Periode: '3',
			Naam: 'Michael La Rosa',
			Club: 'MVV Maastricht',
		},
		{
			Seizoen: '2010-2011',
			Categorie: 'Topscorer',
			Periode: '3',
			Naam: 'Reza Ghoochannjhad',
			Club: 'SC Cambuur',
		},
		{
			Seizoen: '2010-2011',
			Categorie: 'Periodekampioen',
			Periode: '4',
			Naam: 'RKC Waalwijk',
			Club: 'RKC Waalwijk',
		},
		{
			Seizoen: '2010-2011',
			Categorie: 'Beste Speler',
			Periode: '4',
			Naam: 'Marc Hocher',
			Club: 'Helmond Sport',
		},
		{
			Seizoen: '2010-2011',
			Categorie: 'Beste Trainer',
			Periode: '4',
			Naam: 'Ruud Brood',
			Club: 'RKC Waalwijk',
		},
		{
			Seizoen: '2010-2011',
			Categorie: 'Beste Talent',
			Periode: '4',
			Naam: 'Wouter de Vogel',
			Club: 'Telstar',
		},
		{
			Seizoen: '2010-2011',
			Categorie: 'Topscorer',
			Periode: '4',
			Naam: 'Mark de Vries',
			Club: 'SC Cambuur',
		},
	],
	'Bronzen Stieren seizoen 2009/2010': [
		{
			Seizoen: '2009-2010',
			Categorie: 'Periodekampioen',
			Periode: '1',
			Naam: 'Go Ahead Eagles',
			Club: 'Go Ahead Eagles',
		},
		{
			Seizoen: '2009-2010',
			Categorie: 'Beste Speler',
			Periode: '1',
			Naam: 'Halil Çolak',
			Club: 'Go Ahead Eagles',
		},
		{
			Seizoen: '2009-2010',
			Categorie: 'Beste Talent',
			Periode: '1',
			Naam: 'Halil Çolak',
			Club: 'Go Ahead Eagles',
		},
		{
			Seizoen: '2009-2010',
			Categorie: 'Topscorer',
			Periode: '1',
			Naam: 'Fabio Caracciolo',
			Club: 'FC Den Bosch',
		},
		{
			Seizoen: '2009-2010',
			Categorie: 'Beste Trainer',
			Periode: '1',
			Naam: 'Andries Ulderink',
			Club: 'Go Ahead Eagles',
		},
		{
			Seizoen: '2009-2010',
			Categorie: 'Periodekampioen',
			Periode: '2',
			Naam: 'SBV Excelsior',
			Club: 'Excelsior',
		},
		{
			Seizoen: '2009-2010',
			Categorie: 'Beste Speler',
			Periode: '2',
			Naam: 'Mark de Vries',
			Club: 'SC Cambuur',
		},
		{
			Seizoen: '2009-2010',
			Categorie: 'Beste Talent',
			Periode: '2',
			Naam: 'Nacer Chadli',
			Club: 'AGOVV',
		},
		{
			Seizoen: '2009-2010',
			Categorie: 'Topscorer',
			Periode: '2',
			Naam: 'Fabio Caracciolo',
			Club: 'FC Den Bosch',
		},
		{
			Seizoen: '2009-2010',
			Categorie: 'Beste Trainer',
			Periode: '2',
			Naam: 'Andries Ulderink',
			Club: 'Go Ahead Eagles',
		},
		{
			Seizoen: '2009-2010',
			Categorie: 'Periodekampioen',
			Periode: '3',
			Naam: 'FC Eindhoven',
			Club: 'FC Eindhoven',
		},
		{
			Seizoen: '2009-2010',
			Categorie: 'Beste Speler',
			Periode: '3',
			Naam: 'Jules Reimerink',
			Club: 'Go Ahead Eagles',
		},
		{
			Seizoen: '2009-2010',
			Categorie: 'Beste Talent',
			Periode: '3',
			Naam: 'Jules Reimerink',
			Club: 'Go Ahead Eagles',
		},
		{
			Seizoen: '2009-2010',
			Categorie: 'Topscorer',
			Periode: '3',
			Naam: 'Michael de Leeuw',
			Club: 'BV Veendam',
		},
		{
			Seizoen: '2009-2010',
			Categorie: 'Beste Trainer',
			Periode: '3',
			Naam: 'Jan Poortvliet',
			Club: 'FC Eindhoven',
		},
		{
			Seizoen: '2009-2010',
			Categorie: 'Periodekampioen',
			Periode: '4',
			Naam: 'de Graafschap',
			Club: 'de Graafschap',
		},
		{
			Seizoen: '2009-2010',
			Categorie: 'Beste Trainer',
			Periode: '4',
			Naam: 'Darije Kalezic',
			Club: 'De Graafschap',
		},
		{
			Seizoen: '2009-2010',
			Categorie: 'Beste Speler',
			Periode: '4',
			Naam: 'Ruud ter Heide',
			Club: 'FC Emmen',
		},
		{
			Seizoen: '2009-2010',
			Categorie: 'Beste Talent',
			Periode: '4',
			Naam: 'Michael de Leeuw',
			Club: 'BV Veendam',
		},
		{
			Seizoen: '2009-2010',
			Categorie: 'Topscorer',
			Periode: '4',
			Naam: 'Nassir Maachi',
			Club: 'SC Cambuur',
		},
	],
	'Bronzen Stieren seizoen 2008/2009': [
		{
			Seizoen: '2008-2009',
			Categorie: 'Periodekampioen',
			Periode: '1',
			Naam: 'FC Dordrecht',
			Club: 'FC Dordrecht',
		},
		{
			Seizoen: '2008-2009',
			Categorie: 'Beste Speler',
			Periode: '1',
			Naam: 'Cecilio Lopes',
			Club: 'FC Dordrecht',
		},
		{
			Seizoen: '2008-2009',
			Categorie: 'Beste Talent',
			Periode: '1',
			Naam: 'Brian Linssen',
			Club: 'Fortuna Sittard',
		},
		{
			Seizoen: '2008-2009',
			Categorie: 'Topscorer',
			Periode: '1',
			Naam: 'Cecilio Lopes',
			Club: 'FC Dordrecht',
		},
		{
			Seizoen: '2008-2009',
			Categorie: 'Beste Trainer',
			Periode: '1',
			Naam: 'Gert Kruys',
			Club: 'FC Dordrecht',
		},
		{
			Seizoen: '2008-2009',
			Categorie: 'Periodekampioen',
			Periode: '2',
			Naam: 'FC Oss',
			Club: 'FC Oss',
		},
		{
			Seizoen: '2008-2009',
			Categorie: 'Beste Speler',
			Periode: '2',
			Naam: 'Keisuke Honda',
			Club: 'VVV-Venlo',
		},
		{
			Seizoen: '2008-2009',
			Categorie: 'Beste Talent',
			Periode: '2',
			Naam: 'Rick ten Voorde',
			Club: 'FC Emmen',
		},
		{
			Seizoen: '2008-2009',
			Categorie: 'Topscorer',
			Periode: '2',
			Naam: 'Erik Quekel',
			Club: 'FC Oss',
		},
		{
			Seizoen: '2008-2009',
			Categorie: 'Beste Trainer',
			Periode: '2',
			Naam: 'Hans de Koning',
			Club: 'FC Oss',
		},
		{
			Seizoen: '2008-2009',
			Categorie: 'Periodekampioen',
			Periode: '3',
			Naam: 'FC Zwolle',
			Club: 'PEC Zwolle',
		},
		{
			Seizoen: '2008-2009',
			Categorie: 'Beste Speler',
			Periode: '3',
			Naam: 'Keisuke Honda',
			Club: 'VVV-Venlo',
		},
		{
			Seizoen: '2008-2009',
			Categorie: 'Beste Talent',
			Periode: '3',
			Naam: 'Serhat Koç',
			Club: 'FC Eindhoven',
		},
		{
			Seizoen: '2008-2009',
			Categorie: 'Topscorer',
			Periode: '3',
			Naam: 'Jeremy Bokila',
			Club: 'AGOVV',
		},
		{
			Seizoen: '2008-2009',
			Categorie: 'Beste Trainer',
			Periode: '3',
			Naam: 'Roger Reijners',
			Club: 'Fortuna Sittard',
		},
		{
			Seizoen: '2008-2009',
			Categorie: 'Periodekampioen',
			Periode: '4',
			Naam: 'SC Telstar',
			Club: 'Telstar',
		},
		{
			Seizoen: '2008-2009',
			Categorie: 'Beste Speler',
			Periode: '4',
			Naam: 'Keisuke Honda',
			Club: 'VVV-Venlo',
		},
		{
			Seizoen: '2008-2009',
			Categorie: 'Beste Talent',
			Periode: '4',
			Naam: 'Serhat Koç',
			Club: 'FC Eindhoven',
		},
		{
			Seizoen: '2008-2009',
			Categorie: 'Topscorer',
			Periode: '4',
			Naam: 'Sandro Calabro',
			Club: 'VVV-Venlo',
		},
		{
			Seizoen: '2008-2009',
			Categorie: 'Beste Trainer',
			Periode: '4',
			Naam: 'Edward Metgod',
			Club: 'Telstar',
		},
		{
			Seizoen: '2008-2009',
			Categorie: 'Periodekampioen',
			Periode: '5',
			Naam: 'VVV-Venlo',
			Club: 'VVV-Venlo',
		},
		{
			Seizoen: '2008-2009',
			Categorie: 'Beste Speler',
			Periode: '5',
			Naam: 'Adnan Barakat',
			Club: 'FC Den Bosch',
		},
		{
			Seizoen: '2008-2009',
			Categorie: 'Beste Talent',
			Periode: '5',
			Naam: 'Serhat Koç',
			Club: 'FC Eindhoven',
		},
		{
			Seizoen: '2008-2009',
			Categorie: 'Topscorer',
			Periode: '5',
			Naam: 'Sandro Calabro',
			Club: 'VVV-Venlo',
		},
		{
			Seizoen: '2008-2009',
			Categorie: 'Beste Trainer',
			Periode: '5',
			Naam: 'Jan van Dijk',
			Club: 'VVV-Venlo',
		},
		{
			Seizoen: '2008-2009',
			Categorie: 'Periodekampioen',
			Periode: '6',
			Naam: 'S.B.V. Excelsior',
			Club: 'Excelsior',
		},
		{
			Seizoen: '2008-2009',
			Categorie: 'Beste Speler',
			Periode: '6',
			Naam: 'Dries Mertens',
			Club: 'AGOVV',
		},
		{
			Seizoen: '2008-2009',
			Categorie: 'Beste Trainer',
			Periode: '6',
			Naam: 'Jan Everse',
			Club: 'PEC Zwolle',
		},
		{
			Seizoen: '2008-2009',
			Categorie: 'Beste Talent',
			Periode: '6',
			Naam: 'Dries Mertens',
			Club: 'AGOVV',
		},
		{
			Seizoen: '2008-2009',
			Categorie: 'Topscorer',
			Periode: '6',
			Naam: 'Dries Mertens',
			Club: 'AGOVV',
		},
	],
};

export const gouden_stier = {
	'Gouden Stieren seizoen 2017/2018': [
		{
			Seizoen: '2017-2018',
			Categorie: 'Beste Speler',
			Naam: 'Lisandro Semedo',
			Club: 'Fortuna Sittard',
		},
		{
			Seizoen: '2017-2018',
			Categorie: 'Beste Talent',
			Naam: 'Perr Schuurs',
			Club: 'Fortuna Sittard',
		},
		{
			Seizoen: '2017-2018',
			Categorie: 'Beste Trainer',
			Naam: 'Mike Snoei',
			Club: 'Telstar',
		},
		{
			Seizoen: '2017-2018',
			Categorie: 'Topscorer',
			Naam: 'Mart Lieder',
			Club: 'FC Eindhoven',
		},
		{
			Seizoen: '2017-2018',
			Categorie: 'Kampioen',
			Naam: 'Jong Ajax',
			Club: 'Jong Ajax',
		},
		{
			Seizoen: '2017-2018',
			Categorie: 'Winnaar Play-Offs',
			Naam: 'FC Emmen',
			Club: 'FC Emmen',
		},
		{
			Seizoen: '2017-2018',
			Categorie: 'Winnaar Play-Offs',
			Naam: 'De Graafschap',
			Club: 'De Graafschap',
		},
	],
	'Gouden Stieren seizoen 2016/2017': [
		{
			Seizoen: '2016-2017',
			Categorie: 'Beste Speler',
			Naam: 'Abdelhak Nouri',
			Club: 'Jong Ajax',
		},
		{
			Seizoen: '2016-2017',
			Categorie: 'Beste Talent',
			Naam: 'Frenkie de Jong',
			Club: 'Jong Ajax',
		},
		{
			Seizoen: '2016-2017',
			Categorie: 'Beste Trainer',
			Naam: 'Maurice Steijn',
			Club: 'VVV-Venlo',
		},
		{
			Seizoen: '2016-2017',
			Categorie: 'Topscorer',
			Naam: 'Tom Boere',
			Club: 'FC Oss',
		},
		{
			Seizoen: '2016-2017',
			Categorie: 'Kampioen',
			Naam: 'VVV-Venlo',
			Club: 'VVV-Venlo',
		},
		{
			Seizoen: '2016-2017',
			Categorie: 'Winnaar Play-Offs',
			Naam: 'NAC Breda',
			Club: 'NAC Breda',
		},
	],
	'Gouden Stieren seizoen 2015/2016': [
		{
			Seizoen: '2015-2016',
			Categorie: 'Beste Speler',
			Naam: 'Thomas Verhaar',
			Club: 'Sparta Rotterdam',
		},
		{
			Seizoen: '2015-2016',
			Categorie: 'Beste Talent',
			Naam: 'Denzel Dumfries',
			Club: 'Sparta Rotterdam',
		},
		{
			Seizoen: '2015-2016',
			Categorie: 'Beste Trainer',
			Naam: 'Alex Pastoor',
			Club: 'Sparta Rotterdam',
		},
		{
			Seizoen: '2015-2016',
			Categorie: 'Topscorer',
			Naam: 'Ralf Seuntjens',
			Club: 'VVV-Venlo',
		},
		{
			Seizoen: '2015-2016',
			Categorie: 'Kampioen',
			Naam: 'Sparta Rotterdam',
			Club: 'Sparta Rotterdam',
		},
		{
			Seizoen: '2015-2016',
			Categorie: 'Winnaar Play-Offs',
			Naam: 'Go Ahead Eagles',
			Club: 'Go Ahead Eagles',
		},
	],
	'Gouden Stieren seizoen 2014/2015': [
		{
			Seizoen: '2014-2015',
			Categorie: 'Beste Speler',
			Naam: 'Alireza Jahanbakhsh',
			Club: 'NEC Nijmegen',
		},
		{
			Seizoen: '2014-2015',
			Categorie: 'Beste Talent',
			Naam: 'Joey Sleegers',
			Club: 'FC Eindhoven',
		},
		{
			Seizoen: '2014-2015',
			Categorie: 'Beste Trainer',
			Naam: 'Jean-Paul de Jong',
			Club: 'FC Eindhoven',
		},
		{
			Seizoen: '2014-2015',
			Categorie: 'Topscorer',
			Naam: 'Sjoerd Ars',
			Club: 'NEC Nijmegen',
		},
		{
			Seizoen: '2014-2015',
			Categorie: 'Kampioen',
			Naam: 'NEC Nijmegen',
			Club: 'NEC  Nijmegen',
		},
		{
			Seizoen: '2014-2015',
			Categorie: 'Winnaar Play-Offs',
			Naam: 'De Graafschap',
			Club: 'De Graafschap',
		},
		{
			Seizoen: '2014-2015',
			Categorie: 'Winnaar Play-Offs',
			Naam: 'Roda JC',
			Club: 'Roda JC',
		},
	],
	'Gouden Stieren seizoen 2013/2014': [
		{
			Seizoen: '2013-2014',
			Categorie: 'Beste Speler',
			Naam: 'Ruud Boymans',
			Club: 'Willem II',
		},
		{
			Seizoen: '2013-2014',
			Categorie: 'Beste Talent',
			Naam: 'Yoëll van Nieff',
			Club: 'FC Dordrecht',
		},
		{
			Seizoen: '2013-2014',
			Categorie: 'Beste Trainer',
			Naam: 'Jurgen Streppel',
			Club: 'Willem II',
		},
		{
			Seizoen: '2013-2014',
			Categorie: 'Topscorer',
			Naam: 'Lars Veldwijk',
			Club: 'Excelsior',
		},
		{
			Seizoen: '2013-2014',
			Categorie: 'Beste Aanvoerder',
			Naam: 'Jordens Peters',
			Club: 'Willem II',
		},
		{
			Seizoen: '2013-2014',
			Categorie: 'Winnaar Play-Offs',
			Naam: 'SBV Excelsior',
			Club: 'Excelsior',
		},
		{
			Seizoen: '2013-2014',
			Categorie: 'Winnaar Play-Offs',
			Naam: 'FC Dordrecht',
			Club: 'FC Dordrecht',
		},
	],
	'Gouden Stieren seizoen 2012/2013': [
		{
			Seizoen: '2012-2013',
			Categorie: 'Beste Speler',
			Naam: 'Jack Tuyp',
			Club: 'FC Volendam',
		},
		{
			Seizoen: '2012-2013',
			Categorie: 'Beste Talent',
			Naam: 'Quincy Promes',
			Club: 'Go Ahead Eagles',
		},
		{
			Seizoen: '2012-2013',
			Categorie: 'Beste Trainer',
			Naam: 'Hans de Koning',
			Club: 'FC Volendam',
		},
		{
			Seizoen: '2012-2013',
			Categorie: 'Topscorer',
			Naam: 'Jack Tuyp',
			Club: 'FC Volendam',
		},
		{
			Seizoen: '2012-2013',
			Categorie: 'Beste Aanvoerder',
			Naam: 'Tom van Hyfte',
			Club: 'MVV Maastricht',
		},
		{
			Seizoen: '2012-2013',
			Categorie: 'Winnaar Play-Offs',
			Naam: 'Go Ahead Eagles',
			Club: 'Go Ahead Eagles',
		},
	],
	'Gouden Stieren seizoen 2011/2012': [
		{
			Seizoen: '2011-2012',
			Categorie: 'Beste Trainer',
			Naam: 'Art Langeler',
			Club: 'FC Zwolle',
		},
		{
			Seizoen: '2011-2012',
			Categorie: 'Beste Speler',
			Naam: 'Arne Slot',
			Club: 'FC Zwolle',
		},
		{
			Seizoen: '2011-2012',
			Categorie: 'Beste Talent',
			Naam: 'Iliass Bel Hassani',
			Club: 'Sparta Rotterdam',
		},
		{
			Seizoen: '2011-2012',
			Categorie: 'Topscorer',
			Naam: 'Jack Tuyp',
			Club: 'FC Volendam',
		},
		{
			Seizoen: '2011-2012',
			Categorie: 'Winnaar Play-Offs',
			Naam: 'Willem II',
			Club: 'Willem II',
		},
	],
	'Gouden Stieren seizoen 2010/2011': [
		{
			Seizoen: '2010-2011',
			Categorie: 'Beste Speler',
			Naam: 'Mark Hocher',
			Club: 'Helmond Sport',
		},
		{
			Seizoen: '2010-2011',
			Categorie: 'Beste Talent',
			Naam: 'Tjaronn Chery',
			Club: 'FC Emmen',
		},
		{
			Seizoen: '2010-2011',
			Categorie: 'Beste Trainer',
			Naam: 'Ruud Brood',
			Club: 'RKC Waalwijk',
		},
		{
			Seizoen: '2010-2011',
			Categorie: 'Topscorer',
			Naam: 'Johan Voskamp',
			Club: 'Sparta Rotterdam',
		},
	],
	'Gouden Stieren seizoen 2009/2010': [
		{
			Seizoen: '2009-2010',
			Categorie: 'Beste Trainer',
			Naam: 'Darije Kalezic',
			Club: 'De Graafschap',
		},
		{
			Seizoen: '2009-2010',
			Categorie: 'Beste Speler',
			Naam: 'Mark de Vries',
			Club: 'SC Cambuur',
		},
		{
			Seizoen: '2009-2010',
			Categorie: 'Beste Talent',
			Naam: 'Michael de Leeuw',
			Club: 'BV Veendam',
		},
		{
			Seizoen: '2009-2010',
			Categorie: 'Topscorer',
			Naam: 'Michael de Leeuw',
			Club: 'BV Veendam',
		},
		{
			Seizoen: '2009-2010',
			Categorie: 'Winnaar Play-Offs',
			Naam: 'SBV Excelsior',
			Club: 'Excelsior',
		},
	],
	'Gouden Stieren seizoen 2008/2009': [
		{
			Seizoen: '2008-2009',
			Categorie: 'Beste Talent',
			Naam: 'Dries Mertens',
			Club: 'AGOVV',
		},
		{
			Seizoen: '2008-2009',
			Categorie: 'Beste Speler',
			Naam: 'Keisuke Honda',
			Club: 'VVV-Venlo',
		},
		{
			Seizoen: '2008-2009',
			Categorie: 'Beste Trainer',
			Naam: 'Jan van Dijk',
			Club: 'VVV-Venlo',
		},
		{
			Seizoen: '2008-2009',
			Categorie: 'Topscorer',
			Naam: 'Sandro Calabro',
			Club: 'VVV-Venlo',
		},
		{
			Seizoen: '2008-2009',
			Categorie: 'Winnaar Play-Offs',
			Naam: 'RKC Waalwijk',
			Club: 'RKC Waalwijk',
		},
	],
	'Gouden Stieren seizoen 2007/2008': [
		{
			Seizoen: '2007-2008',
			Categorie: 'Beste Speler',
			Naam: 'n/a',
			Club: ' ',
		},
	],
	'Gouden Stieren seizoen 2006/2007': [
		{
			Seizoen: '2006-2007',
			Categorie: 'Beste Speler',
			Naam: 'n/a',
			Club: ' ',
		},
	],
	'Gouden Stieren seizoen 2005/2006': [
		{
			Seizoen: '2005-2006',
			Categorie: 'Beste Speler',
			Naam: 'n/a',
			Club: ' ',
		},
	],
	'Gouden Stieren seizoen 2004/2005': [
		{
			Seizoen: '2004-2005',
			Categorie: 'Beste Speler',
			Naam: 'n/a',
			Club: ' ',
		},
	],
	'Gouden Stieren seizoen 2003/2004': [
		{
			Seizoen: '2003-2004',
			Categorie: 'Beste Speler',
			Naam: 'Klaas-Jan Huntelaar',
			Club: 'AGOVV',
		},
	],
	'Gouden Stieren seizoen 2002/2003': [
		{
			Seizoen: '2002-2003',
			Categorie: 'Beste Speler',
			Naam: 'Donny de Groot',
			Club: 'FC Emmen',
		},
	],
	'Gouden Stieren seizoen 2001/2001': [
		{
			Seizoen: '2001-2001',
			Categorie: 'Beste Speler',
			Naam: 'Thomas Buffel (Bel)',
			Club: 'Excelsior',
		},
	],
	'Gouden Stieren seizoen 2000/2001': [
		{
			Seizoen: '2000-2001',
			Categorie: 'Beste Speler',
			Naam: 'Thomas Buffel (Bel)',
			Club: 'Excelsior',
		},
	],
	'Gouden Stieren seizoen 1999/2000': [
		{
			Seizoen: '1999-2000',
			Categorie: 'Beste Speler',
			Naam: 'David Connolly (Ier)',
			Club: 'Excelsior',
		},
	],
	'Gouden Stieren seizoen 1997/1998': [
		{
			Seizoen: '1997-1998',
			Categorie: 'Beste Speler',
			Naam: 'Peter Wijker',
			Club: 'AZ',
		},
	],
	'Gouden Stieren seizoen 1996/1997': [
		{
			Seizoen: '1996-1997',
			Categorie: 'Beste Speler',
			Naam: 'Michel van Oostrum',
			Club: 'FC Emmen',
		},
	],
	'Gouden Stieren seizoen 1995/1996': [
		{
			Seizoen: '1995-1996',
			Categorie: 'Beste Speler',
			Naam: 'Michel van Oostrum',
			Club: 'FC Emmen',
		},
	],
	'Gouden Stieren seizoen 1993/1994': [
		{
			Seizoen: '1993-1994',
			Categorie: 'Beste Speler',
			Naam: 'Folkert Velten',
			Club: 'Heracles Almelo',
		},
	],
	'Gouden Stieren seizoen 1992/1993': [
		{
			Seizoen: '1992-1993',
			Categorie: 'Beste Speler',
			Naam: 'Virgil Breetveld',
			Club: 'FC Dordrecht',
		},
	],
	'Gouden Stieren seizoen 1991/1992': [
		{
			Seizoen: '1991-1992',
			Categorie: 'Beste Speler',
			Naam: 'John Mutsaers',
			Club: 'RBC',
		},
	],
	'Gouden Stieren seizoen 1990/1991': [
		{
			Seizoen: '1990-1991',
			Categorie: 'Beste Speler',
			Naam: 'Erik Tammer',
			Club: 'Excelsior',
		},
	],
	'Gouden Stieren seizoen 1989/1990': [
		{
			Seizoen: '1989-1990',
			Categorie: 'Beste Speler',
			Naam: 'Ton Cornelissen',
			Club: 'NAC Breda',
		},
	],
	'Gouden Stieren seizoen 1988/1989': [
		{
			Seizoen: '1988-1989',
			Categorie: 'Beste Speler',
			Naam: 'Jerry Cooke',
			Club: 'SVV',
		},
	],
	'Gouden Stieren seizoen 1987/1988': [
		{
			Seizoen: '1987-1988',
			Categorie: 'Beste Speler',
			Naam: 'Frans Thijssen',
			Club: 'Vitesse',
		},
	],
	'Gouden Stieren seizoen 1986/1987': [
		{
			Seizoen: '1986-1987',
			Categorie: 'Beste Speler',
			Naam: 'Marcel Brands',
			Club: 'RKC Waalwijk',
		},
	],
	'Gouden Stieren seizoen 1985/1986': [
		{
			Seizoen: '1985-1986',
			Categorie: 'Beste Speler',
			Naam: 'Peter van Velzen',
			Club: 'RKC Waalwijk',
		},
	],
	'Gouden Stieren seizoen 1984/1985': [
		{
			Seizoen: '1984-1985',
			Categorie: 'Beste Speler',
			Naam: 'Martin Jol',
			Club: 'ADO Den Haag',
		},
	],
	'Gouden Stieren seizoen 1983/1984': [
		{
			Seizoen: '1983-1984',
			Categorie: 'Beste Speler',
			Naam: 'Remy Reynierse',
			Club: 'VVV-Venlo',
		},
	],
};

export const topscorers_statistieken = [
	{
		Seizoen: "25/'26",
		Speler: 'Romano Postema',
		Club: 'FC Emmen',
		Doelpunten: '24',
	},
	{
		Seizoen: "24/'25",
		Speler: 'Henk Veerman ',
		Club: 'FC Volendam',
		Doelpunten: '26',
	},
	{
		Seizoen: "23/'24",
		Speler: 'Henk Veerman ',
		Club: 'ADO Den Haag',
		Doelpunten: '23',
	},
	{
		Seizoen: "22/'23",
		Speler: 'Lennart Thy',
		Club: 'PEC Zwolle',
		Doelpunten: '23',
	},
	{
		Seizoen: "21/'22",
		Speler: 'Thijs Dallinga',
		Club: 'Excelsior Rotterdam',
		Doelpunten: '32',
	},
	{
		Seizoen: "20/'21",
		Speler: 'Robert Mühren',
		Club: 'SC Cambuur',
		Doelpunten: '38',
	},
	{
		Seizoen: "18/'19",
		Speler: 'Ferdy Druijf',
		Club: 'Jong AZ / N.E.C.',
		Doelpunten: '29',
	},
	{
		Seizoen: "17/'18",
		Speler: 'Mart Lieder',
		Club: 'FC Eindhoven',
		Doelpunten: '30',
	},
	{
		Seizoen: "16/'17",
		Speler: 'Tom Boere',
		Club: 'FC Oss',
		Doelpunten: '33',
	},
	{
		Seizoen: "15/'16",
		Speler: 'Ralf Seuntjens',
		Club: 'VVV-Venlo',
		Doelpunten: '28',
	},
	{
		Seizoen: "14/'15",
		Speler: 'Sjoerd Ars',
		Club: 'N.E.C.',
		Doelpunten: '28',
	},
	{
		Seizoen: "13/'14",
		Speler: 'Lars Veldwijk',
		Club: 'Excelsior',
		Doelpunten: '30',
	},
	{
		Seizoen: "12/'13",
		Speler: 'Jack Tuyp',
		Club: 'FC Volendam',
		Doelpunten: '27',
	},
	{
		Seizoen: "11/'12",
		Speler: 'Jack Tuyp',
		Club: 'FC Volendam',
		Doelpunten: '20',
	},
	{
		Seizoen: "10/'11",
		Speler: 'Johan Voskamp',
		Club: 'Sparta Rotterdam',
		Doelpunten: '29',
	},
	{
		Seizoen: "09/'10",
		Speler: 'Michael de Leeuw',
		Club: 'BV Veendam',
		Doelpunten: '25',
	},
	{
		Seizoen: "08/'09",
		Speler: 'Sandro Calabro',
		Club: 'VVV-Venlo',
		Doelpunten: '25',
	},
	{
		Seizoen: "07/'08",
		Speler: 'Jack Tuyp',
		Club: 'FC Volendam',
		Doelpunten: '26',
	},
	{
		Seizoen: "06/'07",
		Speler: 'Berry Powel',
		Club: 'De Graafschap',
		Doelpunten: '29',
	},
	{
		Seizoen: "05/'06",
		Speler: 'Santi Kolk',
		Club: 'PEC Zwolle',
		Doelpunten: '19',
	},
	{
		Seizoen: "05/'06",
		Speler: 'Berry Powel',
		Club: 'FC Den Bosch',
		Doelpunten: '19',
	},
	{
		Seizoen: "04/'05",
		Speler: 'Danny Koevermans',
		Club: 'Sparta Rotterdam',
		Doelpunten: '24',
	},
	{
		Seizoen: "03/'04",
		Speler: 'Klaas-Jan Huntelaar',
		Club: 'AGOVV',
		Doelpunten: '26',
	},
	{
		Seizoen: "02/'03",
		Speler: 'Donny de Groot',
		Club: 'FC Emmen',
		Doelpunten: '30',
	},
	{
		Seizoen: "01/'02",
		Speler: 'Ivan Tsvetkov (Bul)',
		Club: 'BV Veendam',
		Doelpunten: '22',
	},
	{
		Seizoen: "00/'01",
		Speler: 'Stefan Jansen',
		Club: 'FC Oss',
		Doelpunten: '30',
	},
	{
		Seizoen: "99/'00",
		Speler: 'David Connolly (Ier)',
		Club: 'Excelsior',
		Doelpunten: '29',
	},
	{
		Seizoen: "98/'99",
		Speler: 'Harry van der Laan',
		Club: 'FC Den Bosch',
		Doelpunten: '30',
	},
	{
		Seizoen: "97/'98",
		Speler: 'Harry van der Laan',
		Club: 'SC Cambuur',
		Doelpunten: '29',
	},
	{
		Seizoen: "96/'97",
		Speler: 'Michel van Oostrum',
		Club: 'FC Emmen',
		Doelpunten: '25',
	},
	{
		Seizoen: "95/'96",
		Speler: 'Michel van Oostrum',
		Club: 'FC Emmen',
		Doelpunten: '26',
	},
	{
		Seizoen: "94/'95",
		Speler: 'John Mutsaers',
		Club: 'AZ',
		Doelpunten: '23',
	},
	{
		Seizoen: "93/'94",
		Speler: 'Virgil Breetveld',
		Club: 'FC Dordrecht',
		Doelpunten: '27',
	},
	{
		Seizoen: "92/'93",
		Speler: 'Maurice Graef',
		Club: 'VVV-Venlo',
		Doelpunten: '29',
	},
	{
		Seizoen: "91/'92",
		Speler: 'Erik Tammer',
		Club: 'Excelsior',
		Doelpunten: '33',
	},
	{
		Seizoen: "90/'91",
		Speler: 'Ton Cornelissen',
		Club: 'NAC Breda',
		Doelpunten: '35',
	},
	{
		Seizoen: "89/'90",
		Speler: 'Peter van Velzen',
		Club: 'SVV',
		Doelpunten: '24',
	},
	{
		Seizoen: "88/'89",
		Speler: 'Folkert Velten',
		Club: 'Heracles Almelo',
		Doelpunten: '24',
	},
	{
		Seizoen: "87/'88",
		Speler: 'Ad van de Wiel',
		Club: 'RKC Waalwijk',
		Doelpunten: '34',
	},
	{
		Seizoen: "86/'87",
		Speler: 'Henk Grim',
		Club: 'N.E.C.',
		Doelpunten: '29',
	},
	{
		Seizoen: "85/'86",
		Speler: 'Peter van Velzen',
		Club: 'RKC Waalwijk',
		Doelpunten: '28',
	},
	{
		Seizoen: "85/'86",
		Speler: 'Remco Boere',
		Club: 'ADO Den Haag',
		Doelpunten: '28',
	},
	{
		Seizoen: "84/'85",
		Speler: 'Peter van Velzen',
		Club: 'SVV',
		Doelpunten: '28',
	},
	{
		Seizoen: "83/'84",
		Speler: 'Remco Boere',
		Club: 'Vitesse',
		Doelpunten: '27',
	},
	{
		Seizoen: "82/'83",
		Speler: 'Bram Rontberg',
		Club: 'ADO Den Haag',
		Doelpunten: '23',
	},
	{
		Seizoen: "81/'82",
		Speler: 'Piet den Boer',
		Club: 'Excelsior',
		Doelpunten: '26',
	},
	{
		Seizoen: "80/'81",
		Speler: 'Wim Tol',
		Club: 'FC Volendam',
		Doelpunten: '19',
	},
	{
		Seizoen: "79/'80",
		Speler: 'Gerdo Hazelhekke',
		Club: 'FC Wageningen',
		Doelpunten: '23',
	},
	{
		Seizoen: "79/'80",
		Speler: 'Peter Houtman',
		Club: 'FC Groningen',
		Doelpunten: '23',
	},
	{
		Seizoen: "78/'79",
		Speler: 'Cees Schapendonk',
		Club: 'FC Eindhoven',
		Doelpunten: '24',
	},
	{
		Seizoen: "77/'78",
		Speler: 'Peter Houtman',
		Club: 'FC Groningen',
		Doelpunten: '23',
	},
	{
		Seizoen: "76/'77",
		Speler: 'Hans Engbersen',
		Club: 'Fortuna Sittard',
		Doelpunten: '22',
	},
	{
		Seizoen: "75/'76",
		Speler: 'Piet van den Berg',
		Club: 'HFC Haarlem',
		Doelpunten: '25',
	},
	{
		Seizoen: "74/'75",
		Speler: 'Herman Heskamp',
		Club: 'PEC Zwolle',
		Doelpunten: '21',
	},
	{
		Seizoen: "73/'74",
		Speler: 'Herman Veenendaal',
		Club: 'Vitesse',
		Doelpunten: '23',
	},
	{
		Seizoen: "72/'73",
		Speler: 'Johan Zuidema',
		Club: 'SC Cambuur',
		Doelpunten: '25',
	},
	{
		Seizoen: "71/'72",
		Speler: 'Gerdo Hazelhekke',
		Club: 'FC Wageningen',
		Doelpunten: '25',
	},
	{
		Seizoen: "70/'71",
		Speler: 'Bjarne Jensen (Den)',
		Club: 'FC Groningen',
		Doelpunten: '15',
	},
	{
		Seizoen: "69/'70",
		Speler: 'Gerrie Deijkers',
		Club: 'Willem II',
		Doelpunten: '24',
	},
	{
		Seizoen: "68/'69",
		Speler: 'Aad Koudijzer',
		Club: 'SVV',
		Doelpunten: '32',
	},
	{
		Seizoen: "67/'68",
		Speler: 'Sjaak Roggeveen',
		Club: 'Holland Sport',
		Doelpunten: '31',
	},
	{
		Seizoen: "66/'67",
		Speler: 'Dick Tol',
		Club: 'FC Volendam',
		Doelpunten: '33',
	},
	{
		Seizoen: "65/'66",
		Speler: 'Piet Beets',
		Club: "Alkmaar'54",
		Doelpunten: '22',
	},
	{
		Seizoen: "64/'65",
		Speler: 'Willy Sneders',
		Club: 'Willem II',
		Doelpunten: '19',
	},
	{
		Seizoen: "64/'65",
		Speler: 'Hans Roordink',
		Club: 'Enschedese Boys',
		Doelpunten: '19',
	},
	{
		Seizoen: "63/'64",
		Speler: 'Henk Leusink',
		Club: 'Enschedese Boys',
		Doelpunten: '28',
	},
	{
		Seizoen: "62/'63",
		Speler: 'Jan Bouman',
		Club: 'Fortuna Vlaardingen',
		Doelpunten: '27',
	},
	{
		Seizoen: "61/'62",
		Speler: 'Joop Schuman',
		Club: 'Heracles Almelo',
		Doelpunten: '44',
	},
	{
		Seizoen: "60/'61",
		Speler: 'Rick Aspers',
		Club: 'Sittardia',
		Doelpunten: '30',
	},
	{
		Seizoen: "59/'60",
		Speler: 'Joop Schuman',
		Club: 'Heracles Almelo',
		Doelpunten: '28',
	},
	{
		Seizoen: "58/'59",
		Speler: 'Theo Spierings',
		Club: "Helmondia'55",
		Doelpunten: '26',
	},
	{
		Seizoen: "57/'58",
		Speler: 'André Hofman',
		Club: 'Limburgia',
		Doelpunten: '26',
	},
	{
		Seizoen: "56/'57",
		Speler: 'Dick Tol',
		Club: 'FC Volendam',
		Doelpunten: '35',
	},
];

export const totaal_titels = [
	{
		Club: 'FC Volendam',
		'Aantal Titels': '7',
	},
	{
		Club: 'FC Den Bosch',
		'Aantal Titels': '4',
	},
	{
		Club: 'Heracles Almelo',
		'Aantal Titels': '4',
	},
	{
		Club: 'Willem II',
		'Aantal Titels': '4',
	},
	{
		Club: 'ADO Den Haag',
		'Aantal Titels': '4',
	},
	{
		Club: 'De Graafschap',
		'Aantal Titels': '3',
	},
	{
		Club: 'Excelsior',
		'Aantal Titels': '3',
	},
	{
		Club: 'HFC Haarlem',
		'Aantal Titels': '3',
	},
	{
		Club: 'PEC Zwolle',
		'Aantal Titels': '3',
	},
	{
		Club: 'SC Cambuur',
		'Aantal Titels': '3',
	},
	{
		Club: 'Sittardia',
		'Aantal Titels': '3',
	},
	{
		Club: 'VVV-Venlo',
		'Aantal Titels': '3',
	},
	{
		Club: 'AZ',
		'Aantal Titels': '2',
	},
	{
		Club: 'Blauw-Wit',
		'Aantal Titels': '2',
	},
	{
		Club: 'FC Dordrecht',
		'Aantal Titels': '2',
	},
	{
		Club: 'Holland Sport',
		'Aantal Titels': '2',
	},
	{
		Club: 'MVV Maastricht',
		'Aantal Titels': '2',
	},
	{
		Club: 'N.E.C.',
		'Aantal Titels': '2',
	},
	{
		Club: 'RKC Waalwijk',
		'Aantal Titels': '2',
	},
	{
		Club: 'SVV',
		'Aantal Titels': '2',
	},
	{
		Club: 'Vitesse',
		'Aantal Titels': '2',
	},
	{
		Club: "Alkmaar '54",
		'Aantal Titels': '1',
	},
	{
		Club: 'DWS',
		'Aantal Titels': '1',
	},
	{
		Club: 'FC Emmen',
		'Aantal Titels': '1',
	},
	{
		Club: 'FC Groningen',
		'Aantal Titels': '1',
	},
	{
		Club: 'FC Twente',
		'Aantal Titels': '1',
	},
	{
		Club: 'FC Vlaardingen',
		'Aantal Titels': '1',
	},
	{
		Club: 'Fortuna Sittard',
		'Aantal Titels': '1',
	},
	{
		Club: 'GVAV',
		'Aantal Titels': '1',
	},
	{
		Club: 'Helmond Sport',
		'Aantal Titels': '1',
	},
	{
		Club: 'Jong Ajax',
		'Aantal Titels': '1',
	},
	{
		Club: 'NAC Breda',
		'Aantal Titels': '1',
	},
	{
		Club: 'Roda JC Kerkrade',
		'Aantal Titels': '1',
	},
	{
		Club: 'Sparta Rotterdam',
		'Aantal Titels': '1',
	},
];

export const kampioenen = [
	{
		Seizoen: "25/'26",
		Divisie: '-',
		Kampioen: 'ADO Den Haag',
	},
	{
		Seizoen: "24/'25",
		Divisie: '-',
		Kampioen: 'FC Volendam',
	},
	{
		Seizoen: "23/'24",
		Divisie: '-',
		Kampioen: 'Willem II',
	},
	{
		Seizoen: "22/'23",
		Divisie: '-',
		Kampioen: 'Heracles Almelo',
	},
	{
		Seizoen: "21/'22",
		Divisie: '-',
		Kampioen: 'FC Emmen',
	},
	{
		Seizoen: "20/'21",
		Divisie: '-',
		Kampioen: 'SC Cambuur',
	},
	{
		Seizoen: "18/'19",
		Divisie: '-',
		Kampioen: 'FC Twente',
	},
	{
		Seizoen: "17/'18",
		Divisie: '-',
		Kampioen: 'Jong Ajax',
	},
	{
		Seizoen: "16/'17",
		Divisie: '-',
		Kampioen: 'VVV-Venlo',
	},
	{
		Seizoen: "15/'16",
		Divisie: '-',
		Kampioen: 'Sparta Rotterdam',
	},
	{
		Seizoen: "14/'15",
		Divisie: '-',
		Kampioen: 'N.E.C.',
	},
	{
		Seizoen: "13/'14",
		Divisie: '-',
		Kampioen: 'Willem II',
	},
	{
		Seizoen: "12/'13",
		Divisie: '-',
		Kampioen: 'SC Cambuur',
	},
	{
		Seizoen: "11/'12",
		Divisie: '-',
		Kampioen: 'PEC Zwolle',
	},
	{
		Seizoen: "10/'11",
		Divisie: '-',
		Kampioen: 'RKC Waalwijk',
	},
	{
		Seizoen: "09/'10",
		Divisie: '-',
		Kampioen: 'De Graafschap',
	},
	{
		Seizoen: "08/'09",
		Divisie: '-',
		Kampioen: 'VVV-Venlo',
	},
	{
		Seizoen: "07/'08",
		Divisie: '-',
		Kampioen: 'FC Volendam',
	},
	{
		Seizoen: "06/'07",
		Divisie: '-',
		Kampioen: 'De Graafschap',
	},
	{
		Seizoen: "05/'06",
		Divisie: '-',
		Kampioen: 'Excelsior',
	},
	{
		Seizoen: "04/'05",
		Divisie: '-',
		Kampioen: 'Heracles Almelo',
	},
	{
		Seizoen: "03/'04",
		Divisie: '-',
		Kampioen: 'FC Den Bosch',
	},
	{
		Seizoen: "02/'03",
		Divisie: '-',
		Kampioen: 'ADO Den Haag',
	},
	{
		Seizoen: "01/'02",
		Divisie: '-',
		Kampioen: 'PEC Zwolle',
	},
	{
		Seizoen: "00/'01",
		Divisie: '-',
		Kampioen: 'FC Den Bosch',
	},
	{
		Seizoen: "99/'00",
		Divisie: '-',
		Kampioen: 'NAC Breda',
	},
	{
		Seizoen: "98/'99",
		Divisie: '-',
		Kampioen: 'FC Den Bosch',
	},
	{
		Seizoen: "97/'98",
		Divisie: '-',
		Kampioen: 'AZ',
	},
	{
		Seizoen: "96/'97",
		Divisie: '-',
		Kampioen: 'MVV Maastricht',
	},
	{
		Seizoen: "95/'96",
		Divisie: '-',
		Kampioen: 'AZ',
	},
	{
		Seizoen: "94/'95",
		Divisie: '-',
		Kampioen: 'Fortuna Sittard',
	},
	{
		Seizoen: "93/'94",
		Divisie: '-',
		Kampioen: 'FC Dordrecht',
	},
	{
		Seizoen: "92/'93",
		Divisie: '-',
		Kampioen: 'VVV-Venlo',
	},
	{
		Seizoen: "91/'92",
		Divisie: '-',
		Kampioen: 'SC Cambuur',
	},
	{
		Seizoen: "90/'91",
		Divisie: '-',
		Kampioen: 'De Graafschap',
	},
	{
		Seizoen: "89/'90",
		Divisie: '-',
		Kampioen: 'SVV',
	},
	{
		Seizoen: "88/'89",
		Divisie: '-',
		Kampioen: 'Vitesse',
	},
	{
		Seizoen: "87/'88",
		Divisie: '-',
		Kampioen: 'RKC Waalwijk',
	},
	{
		Seizoen: "86/'87",
		Divisie: '-',
		Kampioen: 'FC Volendam',
	},
	{
		Seizoen: "85/'86",
		Divisie: '-',
		Kampioen: 'ADO Den Haag',
	},
	{
		Seizoen: "84/'85",
		Divisie: '-',
		Kampioen: 'Heracles Almelo',
	},
	{
		Seizoen: "83/'84",
		Divisie: '-',
		Kampioen: 'MVV Maastricht',
	},
	{
		Seizoen: "82/'83",
		Divisie: '-',
		Kampioen: "DS'79",
	},
	{
		Seizoen: "81/'82",
		Divisie: '-',
		Kampioen: 'Helmond Sport',
	},
	{
		Seizoen: "80/'81",
		Divisie: '-',
		Kampioen: 'HFC Haarlem',
	},
	{
		Seizoen: "79/'80",
		Divisie: '-',
		Kampioen: 'FC Groningen',
	},
	{
		Seizoen: "78/'79",
		Divisie: '-',
		Kampioen: 'Excelsior',
	},
	{
		Seizoen: "77/'78",
		Divisie: '-',
		Kampioen: 'PEC Zwolle',
	},
	{
		Seizoen: "76/'77",
		Divisie: '-',
		Kampioen: 'Vitesse',
	},
	{
		Seizoen: "75/'76",
		Divisie: '-',
		Kampioen: 'HFC Haarlem',
	},
	{
		Seizoen: "74/'75",
		Divisie: '-',
		Kampioen: 'N.E.C.',
	},
	{
		Seizoen: "73/'74",
		Divisie: '-',
		Kampioen: 'Excelsior',
	},
	{
		Seizoen: "72/'73",
		Divisie: '-',
		Kampioen: 'Roda JC',
	},
	{
		Seizoen: "71/'72",
		Divisie: '-',
		Kampioen: 'HFC Haarlem',
	},
	{
		Seizoen: "70/'71",
		Divisie: '-',
		Kampioen: 'FC Den Bosch',
	},
	{
		Seizoen: "69/'70",
		Divisie: '-',
		Kampioen: 'FC Volendam',
	},
	{
		Seizoen: "68/'69",
		Divisie: '-',
		Kampioen: 'SVV',
	},
	{
		Seizoen: "67/'68",
		Divisie: '-',
		Kampioen: 'Holland Sport',
	},
	{
		Seizoen: "66/'67",
		Divisie: '-',
		Kampioen: 'FC Volendam',
	},
	{
		Seizoen: "65/'66",
		Divisie: '-',
		Kampioen: 'Sittardia',
	},
	{
		Seizoen: "64/'65",
		Divisie: '-',
		Kampioen: 'Willem II',
	},
	{
		Seizoen: "63/'64",
		Divisie: '-',
		Kampioen: 'Sittardia',
	},
	{
		Seizoen: "62/'63",
		Divisie: '-',
		Kampioen: 'DWS',
	},
	{
		Seizoen: "61/'62",
		Divisie: 'B',
		Kampioen: 'Heracles Almelo',
	},
	{
		Seizoen: "61/'62",
		Divisie: 'A',
		Kampioen: 'Fortuna Vlaardingen',
	},
	{
		Seizoen: "60/'61",
		Divisie: 'B',
		Kampioen: 'Blauw Wit',
	},
	{
		Seizoen: "60/'61",
		Divisie: 'A',
		Kampioen: 'FC Volendam',
	},
	{
		Seizoen: "59/'60",
		Divisie: 'B',
		Kampioen: "Alkmaar'54",
	},
	{
		Seizoen: "59/'60",
		Divisie: 'A',
		Kampioen: 'GVAV',
	},
	{
		Seizoen: "58/'59",
		Divisie: 'B',
		Kampioen: 'Sittardia',
	},
	{
		Seizoen: "58/'59",
		Divisie: 'A',
		Kampioen: 'FC Volendam',
	},
	{
		Seizoen: "57/'58",
		Divisie: 'B',
		Kampioen: 'SHS',
	},
	{
		Seizoen: "57/'58",
		Divisie: 'A',
		Kampioen: 'Willem II',
	},
	{
		Seizoen: "56/'57",
		Divisie: 'B',
		Kampioen: 'Blauw Wit',
	},
	{
		Seizoen: "56/'57",
		Divisie: 'A',
		Kampioen: 'ADO',
	},
];

export const club_data_stats = [
	{
		Club: 'FC Eindhoven',
		jaren: '66',
	},
	{
		Club: 'FC Dordrecht',
		jaren: '61',
	},
	{
		Club: 'Helmond Sport',
		jaren: '57',
	},
	{
		Club: 'SC Cambuur',
		jaren: '52',
	},
	{
		Club: 'Telstar',
		jaren: '48',
	},
	{
		Club: 'SC Veendam',
		jaren: '48',
	},
	{
		Club: 'FC Den Bosch',
		jaren: '48',
	},
	{
		Club: 'Heracles Almelo',
		jaren: '43',
	},
	{
		Club: 'FC Volendam',
		jaren: '42',
	},
	{
		Club: 'VVV-Venlo',
		jaren: '43',
	},
	{
		Club: 'De Graafschap',
		jaren: '42',
	},
	{
		Club: 'Excelsior',
		jaren: '41',
	},
	{
		Club: 'FC Emmen',
		jaren: '38',
	},
	{
		Club: 'Fortuna Sittard',
		jaren: '31',
	},
	{
		Club: 'Go Ahead Eagles',
		jaren: '31',
	},
	{
		Club: 'MVV Maastricht',
		jaren: '35',
	},
	{
		Club: 'TOP Oss',
		jaren: '32',
	},
	{
		Club: 'PEC Zwolle',
		jaren: '30',
	},
	{
		Club: 'SVV',
		jaren: '29',
	},
	{
		Club: 'HFC Haarlem',
		jaren: '28',
	},
	{
		Club: 'FC Wageningen',
		jaren: '27',
	},
	{
		Club: 'Vitesse',
		jaren: '26',
	},
	{
		Club: 'sc Heerenveen',
		jaren: '24',
	},
	{
		Club: 'Willem II',
		jaren: '22',
	},
	{
		Club: 'ADO Den Haag',
		jaren: '21',
	},
	{
		Club: 'FC Vlaardingen',
		jaren: '19',
	},
	{
		Club: 'Almere City FC',
		jaren: '19',
	},
	{
		Club: 'NEC',
		jaren: '17',
	},
	{
		Club: 'NAC Breda',
		jaren: '17',
	},
	{
		Club: 'AGOVV',
		jaren: '16',
	},
	{
		Club: 'De Volewijckers',
		jaren: '15',
	},
	{
		Club: 'D.F.C.',
		jaren: '12',
	},
	{
		Club: 'HVC',
		jaren: '12',
	},
	{
		Club: 'RKC Waalwijk',
		jaren: '13',
	},
	{
		Club: 'Holland Sport',
		jaren: '11',
	},
	{
		Club: 'GVAV/FC Groningen',
		jaren: '11',
	},
	{
		Club: 'AZ',
		jaren: '11',
	},
	{
		Club: 'SHS',
		jaren: '11',
	},
	{
		Club: 'SC Amersfoort',
		jaren: '10',
	},
	{
		Club: 'Blauw Wit',
		jaren: '10',
	},
	{
		Club: 'Sparta Rotterdam',
		jaren: '10',
	},
	{
		Club: 'Jong PSV',
		jaren: '11',
	},
	{
		Club: 'Jong Ajax',
		jaren: '11',
	},
	{
		Club: 'Roda JC',
		jaren: '10',
	},
	{
		Club: "Alkmaar '54",
		jaren: '8',
	},
	{
		Club: 'Sittardia',
		jaren: '8',
	},
	{
		Club: 'DHC',
		jaren: '8',
	},
	{
		Club: "Alkmaar '54",
		jaren: '8',
	},
	{
		Club: 'USV Elinkwijk',
		jaren: '7',
	},
	{
		Club: 'Limburgia',
		jaren: '7',
	},
	{
		Club: 'Jong FC Utrecht',
		jaren: '8',
	},
	{
		Club: 'Hermes DVS',
		jaren: '6',
	},
	{
		Club: 'vv Helmond',
		jaren: '6',
	},
	{
		Club: 'KFC',
		jaren: '6',
	},
	{
		Club: 'Velox',
		jaren: '6',
	},
	{
		Club: 'VSV',
		jaren: '6',
	},
	{
		Club: 'Stormvogels',
		jaren: '6',
	},
	{
		Club: 'Jong AZ',
		jaren: '7',
	},
	{
		Club: "Helmondia '55",
		jaren: '5',
	},
	{
		Club: 'VV Leeuwarden',
		jaren: '5',
	},
	{
		Club: 'BVV',
		jaren: '5',
	},
	{
		Club: 'Enschedese Boys',
		jaren: '5',
	},
	{
		Club: 'VV Rigtersbleek',
		jaren: '4',
	},
	{
		Club: 'ZFC',
		jaren: '4',
	},
	{
		Club: 'FC Amsterdam',
		jaren: '4',
	},
	{
		Club: "Achilles'29",
		jaren: '4',
	},
	{
		Club: 'Xerxes',
		jaren: '3',
	},
	{
		Club: 'Roda Sport',
		jaren: '3',
	},
	{
		Club: 'EDO',
		jaren: '3',
	},
	{
		Club: 'EBOH',
		jaren: '3',
	},
	{
		Club: 'DWS',
		jaren: '3',
	},
	{
		Club: "SC 't Gooi",
		jaren: '3',
	},
	{
		Club: 'Be Quick',
		jaren: '2',
	},
	{
		Club: 'VCV Zeeland',
		jaren: '2',
	},
	{
		Club: 'VC Vlissingen',
		jaren: '2',
	},
	{
		Club: 'Jong FC Twente',
		jaren: '2',
	},
	{
		Club: 'NOAD',
		jaren: '2',
	},
	{
		Club: 'Jong AZ',
		jaren: '2',
	},
	{
		Club: 'FC Twente',
		jaren: '2',
	},
	{
		Club: 'RKVV Wilhelmina',
		jaren: '1',
	},
	{
		Club: 'FC Zaanstreek',
		jaren: '1',
	},
	{
		Club: 'SC Drente',
		jaren: '1',
	},
	{
		Club: 'FC Hilversum',
		jaren: '1',
	},
	{
		Club: 'SC Emma',
		jaren: '1',
	},
];

// Updated club data stats from CSV (October 2025)
export const club_data_stats_updated = [
	{
		Club: 'FC Eindhoven',
		jaren: '65',
	},
	{
		Club: 'FC Dordrecht',
		jaren: '60',
	},
	{
		Club: 'Helmond Sport',
		jaren: '56',
	},
	{
		Club: 'SC Cambuur',
		jaren: '52',
	},
	{
		Club: 'Telstar',
		jaren: '48',
	},
	{
		Club: 'SC Veendam',
		jaren: '48',
	},
	{
		Club: 'FC Den Bosch',
		jaren: '47',
	},
	{
		Club: 'Heracles Almelo',
		jaren: '43',
	},
	{
		Club: 'FC Volendam',
		jaren: '42',
	},
	{
		Club: 'VVV-Venlo',
		jaren: '42',
	},
	{
		Club: 'De Graafschap',
		jaren: '41',
	},
	{
		Club: 'Excelsior',
		jaren: '41',
	},
	{
		Club: 'FC Emmen',
		jaren: '37',
	},
	{
		Club: 'RBC Roosendaal',
		jaren: '35',
	},
	{
		Club: 'MVV Maastricht',
		jaren: '34',
	},
	{
		Club: 'TOP Oss',
		jaren: '34',
	},
	{
		Club: 'Fortuna Sittard',
		jaren: '31',
	},
	{
		Club: 'Go Ahead Eagles',
		jaren: '31',
	},
	{
		Club: 'PEC Zwolle',
		jaren: '30',
	},
	{
		Club: 'SVV',
		jaren: '29',
	},
	{
		Club: 'HFC Haarlem',
		jaren: '28',
	},
	{
		Club: 'Vitesse',
		jaren: '27',
	},
	{
		Club: 'FC Wageningen',
		jaren: '27',
	},
	{
		Club: 'sc Heerenveen',
		jaren: '24',
	},
	{
		Club: 'ADO Den Haag',
		jaren: '23',
	},
	{
		Club: 'Willem II',
		jaren: '23',
	},
	{
		Club: 'Almere City FC',
		jaren: '19',
	},
	{
		Club: 'FC Vlaardingen',
		jaren: '19',
	},
	{
		Club: 'NAC Breda',
		jaren: '18',
	},
	{
		Club: 'N.E.C.',
		jaren: '17',
	},
	{
		Club: 'AGOVV Apeldoorn',
		jaren: '15',
	},
	{
		Club: 'De Volewijckers',
		jaren: '15',
	},
	{
		Club: 'Jong Ajax',
		jaren: '13',
	},
	{
		Club: 'Jong PSV',
		jaren: '13',
	},
	{
		Club: 'RKC Waalwijk',
		jaren: '13',
	},
	{
		Club: 'HVC',
		jaren: '12',
	},
	{
		Club: 'Roda JC Kerkrade',
		jaren: '12',
	},
	{
		Club: 'AZ',
		jaren: '11',
	},
	{
		Club: 'Holland Sport',
		jaren: '11',
	},
	{
		Club: 'Blauw-Wit',
		jaren: '10',
	},
	{
		Club: 'Jong FC Utrecht',
		jaren: '10',
	},
	{
		Club: 'Sparta Rotterdam',
		jaren: '10',
	},
	{
		Club: 'FC Groningen',
		jaren: '9',
	},
	{
		Club: 'Jong AZ',
		jaren: '9',
	},
	{
		Club: 'RCH',
		jaren: '9',
	},
	{
		Club: 'SC Amersfoort',
		jaren: '9',
	},
	{
		Club: "Alkmaar '54",
		jaren: '8',
	},
	{
		Club: 'DHC',
		jaren: '8',
	},
	{
		Club: 'Sittardia',
		jaren: '8',
	},
	{
		Club: 'USV Elinkwijk',
		jaren: '7',
	},
	{
		Club: 'Limburgia',
		jaren: '7',
	},
	{
		Club: 'Hermes DVS',
		jaren: '6',
	},
	{
		Club: 'HVV Helmond',
		jaren: '6',
	},
	{
		Club: 'KFC',
		jaren: '6',
	},
	{
		Club: 'Stormvogels',
		jaren: '6',
	},
	{
		Club: 'Velox',
		jaren: '6',
	},
	{
		Club: 'VSV',
		jaren: '6',
	},
	{
		Club: 'BVV',
		jaren: '5',
	},
	{
		Club: 'Enschedese Boys',
		jaren: '5',
	},
	{
		Club: "Helmondia '55",
		jaren: '5',
	},
	{
		Club: 'vv Leeuwarden',
		jaren: '5',
	},
	{
		Club: "Achilles'29",
		jaren: '4',
	},
	{
		Club: 'FC Amsterdam',
		jaren: '4',
	},
	{
		Club: 'vv Rigtersbleek',
		jaren: '4',
	},
	{
		Club: 'ZFC',
		jaren: '4',
	},
	{
		Club: 'DWS',
		jaren: '3',
	},
	{
		Club: 'EBOH',
		jaren: '3',
	},
	{
		Club: 'EDO',
		jaren: '3',
	},
	{
		Club: 'GVAV',
		jaren: '3',
	},
	{
		Club: 'Roda Sport',
		jaren: '3',
	},
	{
		Club: "SC 't Gooi",
		jaren: '3',
	},
	{
		Club: 'XerxesDZB',
		jaren: '3',
	},
	{
		Club: 'Be Quick 1887',
		jaren: '2',
	},
	{
		Club: 'FC Twente',
		jaren: '2',
	},
	{
		Club: 'Jong FC Twente',
		jaren: '2',
	},
	{
		Club: 'NOAD',
		jaren: '2',
	},
	{
		Club: 'VC Vlissingen',
		jaren: '2',
	},
	{
		Club: 'FC Hilversum',
		jaren: '1',
	},
	{
		Club: 'FC Zaanstreek',
		jaren: '1',
	},
	{
		Club: 'RKVV Wilhelmina',
		jaren: '1',
	},
	{
		Club: 'SC Drente',
		jaren: '1',
	},
	{
		Club: 'SC Emma',
		jaren: '1',
	},
];
